import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import common from "../../services/common.js";
import scroll from "../../services/scroll.js";
import env from "../../services/env.js";
import messaging from "../../services/messagingv2.js";
import async from "async";

const METER_RADIUS = 1000;
const METER_THRESHOLD = 500;
const RED_ICON = "url(/app/vendor/images/check-out-icon-2.png)";
const GREEN_ICON = "url(/app/vendor/images/check-in-icon-2.png)";
const CIRCLE_COLOR = "#62C046";
const CIRCLE_OPACITY = 0.35;
const QUIT_REASONS = [
  {name: "DECLINED_ALL_SHIFTS", description: "Declined all shifts."},
  {name: "OTHER_WORK_HIGHER_PAY", description: "Found other work with higher pay elsewhere."},
  {name: "OTHER_WORK_CLOSER_TO_HOME", description: "Found other work closer to home."},
  {name: "OTHER_WORK_PREFERRED_WORKING_HOURS", description: "Found other work with more preferred working hours."},
  {name: "OTHER_WORK_MORE_INTERESTING_TASKS", description: "Found other work with more interesting tasks."},
  {name: "OTHER_WORK_OTHER_REASON_NOT_LISTED_HERE", description: "Found other work."},
  {name: "SOMETHING_CAME_UP_CHANGE_IN_SCHEDULE", description: "Something came up - change in schedule."},
  {name: "SOMETHING_CAME_UP_EMERGENCY", description: "Something came up - emergency."},
  {name: "SOMETHING_CAME_UP_TRANSPORTATION_ISSUES", description: "Transportation issues."},
  {name: "SOMETHING_CAME_UP_NO_LONGER_MEET_REQUIREMENTS", description: "No longer meets job requirements."},
  {name: "SOMETHING_CAME_UP_OTHER_REASON_NOT_LISTED_HERE", description: "Something came up."},
  {name: "BAD_FIT_TOO_CHALLENGING", description: "Work was a bad fit - too challenging."},
  {name: "BAD_FIT_TOO_FAR", description: "Work was a bad fit - job site too far."},
  {name: "BAD_FIT_PAY_RATE_TOO_LOW", description: "Work was a bad fit - pay rate was too low."},
  {name: "BAD_FIT_UNSUPPORTIVE_WORK_ENVIRONMENT", description: "Unsupportive work enviornment."},
  {name: "BAD_FIT_OTHER_REASON_NOT_LISTED_HERE", description: "Bad fit."},
];

class EventreviewapplicantsController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    EventsService,
    $stateParams,
    SecurityService,
    CommonService,
    ScrollService,
    $rootScope,
    $scope,
    $window,
    EnvService,
    $timeout,
    Messagingv2Service,
    TrackingService,
    $anchorScroll,
    $location
  ) {
    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }
    $localStorage.activeStateName = "events";
    this.name = "eventreviewapplicants";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$security = SecurityService;
    this.$common = CommonService;
    this.$scroll = ScrollService;
    this.$window = $window;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$messagingv2 = Messagingv2Service;
    this.$anchor = $anchorScroll;
    this.$env = EnvService;
    this.$location = $location;
    this.$timeout = $timeout;
    this.showAppWarning = false;
    this.currentUser = this.$auth.getUserData();
    this.applicationForReject = null;
    this.currentPageNumber = 1;
    this.busy = true;
    this.busyAccepted = true;
    this.updatingHoursWorkedBackend = false;
    this.$tracking = TrackingService;
    this.useBottom = false;
    this.remain_loading_count = 0;
    this.event = {};
    this.isThereRoomForHire = null;
    this.acceptedApplicantsDoneLoading = false;
    this.pendingApplicantsDoneLoading = false;
    this.allApplicantsDoneLoading = false;
    this.getUserTimeZone();
    this.rejectedApplicantsDoneLoading = false;
    this.pendingApplicants = [];
    this.acceptedApplicants = [];
    this.approvedApplicants = [];
    this.readyToPay = [];
    this.selectedApplicant = {};
    this.hireJobblerResult = {};
    this.removeJobblerResult = {};
    this.selectedHireApplicant = 0;
    this.paymentInfos = this.currentUser.company.paymentInfos;
    this.fakeApplicants = [1, 2, 3, 4, 5];
    this.singleShiftView = false;
    this.singleShiftViewId = null;
    this.singleShiftViewShift = null;
    this.singleShiftViewFormatted = null;
    this.sortOrder = "asc";
    this.sortField = "lastName";
    this.jobQuery = "";
    this.lastJobQuery = "";
    this.csvName = "Roster " + moment().format("MMMM Do YYYY") + ".csv";

    this.additionalPaymentAmount = 0;
    this.additionalPaymentAmountJobbler = 0;

    this.showMap = false;

    this.ui = {
      allChecked: false,
    };

    this.confirmationFilters = {
      all: true,
      confirmed: false,
      declined: false,
      no_response: false,
    };

    this.confirmationFilterText = "ALL";

    this.loadingShiftConfirmationDataByShift = {};

    this.confirmationNumbers = {};
    this.convertedShiftsMap = {};

    this.paymentContingenciesMap = {};
    this.paymentContingenciesShiftPositions = [];

    this.statusNumbers = {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
    };

    this.editCheckInTimes = {};
    this.editCheckOutTimes = {};

    this.tabFilter = 1;

    var _this = this;

    $scope.statusFilter = function (item) {
      return item.applicationStatusRoster.id === _this.tabFilter;
    };

    $scope.confirmationStatusFilter = function (applicant) {
      let confirmationResponseExists = false;
      let confirmationResponse = false;
      let groupNumber = 2;

      if (
        _this.shiftConfirmationData &&
        _this.shiftConfirmationData[_this.singleShiftViewShiftPosition] &&
        _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId]
      ) {
        //console.log("lets look at the confirmation data");
        //console.dir(_this.shiftConfirmationData[_this.singleShiftViewShiftPosition]);
        //console.dir(_this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId]);
        //console.dir(_this.shiftConfirmationData);

        confirmationResponseExists =
          _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
        confirmationResponse = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse;
        groupNumber = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].groupNumber;
        applicant.groupNumber = groupNumber;
        applicant.confirmationResponse = confirmationResponse;
        applicant.confirmationResponseExists = confirmationResponseExists;
      }

      if (groupNumber !== 1) return false;

      if (_this.confirmationFilters.all) return true;

      if (_this.confirmationFilters.confirmed && confirmationResponseExists && confirmationResponse) return true;

      if (_this.confirmationFilters.declined && confirmationResponseExists && !confirmationResponse) return true;

      if (_this.confirmationFilters.no_response && !confirmationResponseExists) return true;

      return false;
    };

    $scope.confirmationStatusFilterUnPrioritized = function (applicant) {
      let confirmationResponseExists = false;
      let confirmationResponse = false;
      let groupNumber = 2;

      if (
        _this.shiftConfirmationData &&
        _this.shiftConfirmationData[_this.singleShiftViewShiftPosition] &&
        _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId]
      ) {
        confirmationResponseExists =
          _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
        confirmationResponse = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse;
        groupNumber = _this.shiftConfirmationData[_this.singleShiftViewShiftPosition][applicant.applicantId].groupNumber;
      }

      //console.log("groupNumber", groupNumber);
      if (groupNumber === 1) {
        return false;
      }

      if (_this.confirmationFilters.all) return true;

      if (_this.confirmationFilters.confirmed && confirmationResponseExists && confirmationResponse) return true;

      if (_this.confirmationFilters.declined && confirmationResponseExists && !confirmationResponse) return true;

      if (_this.confirmationFilters.no_response && !confirmationResponseExists) return true;

      return false;
    };

    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
      this.currentUser.isAdmin = true;
    }

    this.initialLoadingApplicants = true;

    this.setLoader();
    this.$events.getEventByIdTrimmedv2(this.$stateParams.eventId).then(
      (data) => {
        //_this.unSetLoader();
        _this.event = data.data;
        _this.csvName = `Roster - ${_this.event.name} - ${moment().format("MMMM Do YYYY")}.csv`;

        console.log("event", _this.event.name);

        var pageArray = [];
        var pageArrayAccepted = [];
        _this.setTableHeaders();
        _this.isSourcingPost = _this.event.isSourcingPost;
        _this.$timeout(function () {
          $("eventsidebar .jobs-complete-sidebar li:nth-child(2)").removeClass().addClass("active");
        }, 500);
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetEventToEventSidebar", {
            event: _this.event,
          });
        });
        var numberOfPendingApplications = Math.ceil(_this.event.numberOfPendingApplications / 12);
        for (var i = 0; i < numberOfPendingApplications; i++) {
          pageArray.push(i + 1);
          _this.pages = pageArray;
        }
        var numberOfApprovedApplications = Math.ceil(_this.event.numberOfApprovedApplications / 10);
        for (var i = 0; i < numberOfApprovedApplications; i++) {
          pageArrayAccepted.push(i + 1);
          _this.acceptedPages = pageArrayAccepted;
        }
        if (_this.event.status === "error") {
          return;
        }
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetEventToEventDialog", {
            event: _this.event,
          });
        });

        const jobblePoolId = _this.event.subEvents[0].deduppedJobbles[0].jobblePoolId;
        const subEventId = _this.event.subEvents[0].id;
        let eventResp = data.data;
        this.loadAllApplicants(jobblePoolId, true, eventResp, subEventId);
        this.checkEventOpenings(data.data.id);
        //this.loadShiftConfirmationData(subEventId);
        return console.error("testing this stop");
      },
      function (data) {
        console.log("we have an error loading the event");
        console.dir(data);
        alert("Critical error loading job roster - please contact support.");
        //$state.go("events");
      }
    );

    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
      if (_this.event.id === params.event.id) {
        _this.event.cost = params.event.cost;
        let remaining_openings = 0;
        if (params.action === "Remove") {
          remaining_openings = params.event.numberOfOpenings - params.openings;
          if (remaining_openings < 0) {
            _this.event.numberOfOpenings = 0;
          } else {
            _this.event.numberOfOpenings = remaining_openings;
          }
        } else {
          _this.event.numberOfOpenings = params.event.numberOfOpenings + params.openings;
        }
        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
      }
    });

    _this.RejectFromProfileScreenListener = _this.$rootScope.$on("RejectFromProfileScreen", function ($event, params) {
      _this.confirmRemoveJobbler(params.status, params.jobbler);
    });

    _this.SuccessToDeleteEventListener = _this.$rootScope.$on("SuccessToDeleteEvent", function () {
      _this.$state.go("jobsdashboard");
    });

    _this.PaginateApplicationsListener = _this.$rootScope.$on("PaginateApplications", function ($event, params) {
      _this.handleProfilePagination(params);
    });

    _this.UpdatedCreditCardListener = _this.$rootScope.$on("UpdatedCreditCard", function ($event, params) {
      _this.currentUser.company.paymentInfos = params.user.company.paymentInfos;
      _this.paymentInfos = params.user.company.paymentInfos;
    });

    _this.HireJobblerFromProfileListener = _this.$rootScope.$on("HireJobblerFromProfile", function ($event, params) {
      var arg = {};
      arg.action = "close";
      params.application.isHireSelected = true;
      _this.approvedApplicants = [];
      _this.approvedApplicants.push(params.application);
      _this.hireJobblers(arg);
    });

    _this.SetApplicationToPendingListener = _this.$rootScope.$on("SetApplicationToPending", function ($event, app) {
      _this.mapRejectedApplicantToPendingApplicants(app);
    });

    _this.$scope.$on("$destroy", _this.HireJobblerFromProfileListener);
    _this.$scope.$on("$destroy", _this.RejectFromProfileScreenListener);
    _this.$scope.$on("$destroy", _this.SetApplicationToPendingListener);
    _this.$scope.$on("$destroy", _this.HireJobblerFromPorfileListener);
    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
    //_this.$scope.$on('$destroy', _this.channelsHaveBeenLoadedListener);
    _this.$scope.$on("$destroy", _this.PaginateApplicationsListener);
    _this.$scope.$on("$destroy", _this.UpdatedCreditCardListener);

    this.organizePaymentOptions(this.currentUser);
  }

  onClickUpdateHours(applicantId) {
    const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];
    if (shiftData.isEditingMinutes) {
      this.blurHoursUpdated(shiftData);
      this.$tracking.reportRosterPageSubmit("payment - edit hours");
    }
  }

  toggleShowUnconfirmed() {
    this.showUnconfirmedApplicants = !this.showUnconfirmedApplicants;
  }

  processShifts(event) {

    if (!event || !event.subEvents || !event.subEvents.length || !event.subEvents[0].deduppedJobbles || !event.subEvents[0].deduppedJobbles.length)
      return console.error("Error processing shifts from event");

    const jobble = event.subEvents[0].deduppedJobbles[0];

    if (!jobble || !jobble.shifts || !jobble.shifts.length) return console.error("Error processing shifts from jobble or shifts array is empty");

    const shifts = jobble.shifts;
    let convertedShifts = this.convertShifts(shifts);

    this.convertedShiftsMap = {};
    if (convertedShifts && convertedShifts.length) {
      convertedShifts.forEach((convertedShift) => {
        this.convertedShiftsMap[convertedShift.shiftPosition] = convertedShift;
      });
    }

    convertedShifts = convertedShifts.sort((a, b) => {
      return new Date(`${a.startDate} ${a.startTime}`).getTime() - new Date(`${b.startDate} ${b.startTime}`).getTime();
    });

    console.log("convertedShifts:", convertedShifts);

    this.shiftOptions = convertedShifts;

    if (!this.singleShiftViewShift) {
      this.setSingleShiftView(convertedShifts[0], 0);
    }

    convertedShifts.forEach((shift) => {
      this.$timeout(() => {
        this.loadSingleShiftConfirmationData(shift.id, shift.shiftPosition, shift);
      });
    });

    /*
    this.$timeout(() => {
      console.log("is this the last thing i see");
      this.unSetLoader();
    }, 6000);
    */
  }

  toggleMap() {
    this.showMap = !this.showMap;

    this.$timeout(() => {
      this.initializeMap();
    });
  }

  calculateConfirmationNumber() {
    let confirmationCounter = 0;
  }

  setConfirmationNumbers() {
    if (!this.shiftOptions || !this.shiftConfirmationData || !this.hiredApplicants) return;

    this.confirmationNumbers = {};
    try {
      this.shiftOptions.map((shift) => {
        this.confirmationNumbers[shift.shiftPosition] = 0;
        this.hiredApplicants.map((applicant) => {
          if (applicant.bgCheckStatus === "Pending") {
            return;
          }
          if (!this.shiftConfirmationData[shift.shiftPosition] || !this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId]) return;

          if (!this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId].confirmationResponseExists) return;

          if (this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId].confirmationResponse) {
            this.confirmationNumbers[shift.shiftPosition] += 1;
          }
        });
      });
    } finally {
      //console.log("in the finally");
      //console.dir(this.confirmationNumbers);
    }
  }

  setSingleShiftView(shift, index) {

    this.singleShiftView = true;

    this.singleShiftViewId = shift.id;
    this.singleShiftViewShift = shift;
    this.singleShiftViewShiftPosition = shift.shiftPosition;
    this.singleShiftViewOriginalIndex = index;
    //timeZone change here
    this.singleShiftViewFormatted = `Shift ${index + 1}: ${shift.shiftDateFormatted} ${shift.shiftStartTimeLoc} -> ${shift.shiftEndTimeLoc} ${
      shift.shiftTZ
    } ${shift.shiftEnded ? " (ended)" : ""}${shift.shiftLive ? " (live)" : ""}`;

    console.log("this.singleShiftViewFormatted");
    console.dir(this.singleShiftViewFormatted);

    //this.loadShiftConfirmationData(shift.id);
    this.checkOrUncheckAll(false);
    this.calculateConfirmationNumber();
    this.ui.allChecked = false;

    this.$tracking.reportRosterPageClick("single shift view");

    this.reSortHired();

    this.$timeout(() => {
      this.initializeMap();
      this.processWhoCanBePaid();
    }, 1300);

    if (!shift.shiftStarted) {
      this.showMap = false;
    } else {
      this.showMap = true;
    }
    this.prepareAllApplicantsCSV(this.allApplicants);

    //this.setFakeLoader(750);

    this.enableToolTips();
  }

  setFakeLoader(time) {
    this.setLoader();

    this.$timeout(() => {
      this.unSetLoader();
    }, time);
  }

  setAll() {
    this.$timeout(() => {
      this.confirmationFilters = {
        all: true,
        confirmed: false,
        declined: false,
        no_response: false,
      };

      this.confirmationFilterText = "ALL";
    }, 10);
  }

  checkConfirmationFilters() {
    this.$timeout(() => {
      if (!this.confirmationFilters) return;

      if (this.confirmationFilters.confirmed && this.confirmationFilters.declined && this.confirmationFilters.no_response) {
        this.$timeout(() => {
          this.confirmationFilters = {
            all: true,
            confirmed: false,
            declined: false,
            no_response: false,
          };
          this.confirmationFilterText = "ALL";
        }, 1);
      }

      if (
        !(this.confirmationFilters.confirmed && this.confirmationFilters.declined && this.confirmationFilters.no_response) &&
        (this.confirmationFilters.confirmed || this.confirmationFilters.declined || this.confirmationFilters.no_response)
      ) {
        console.log("Seetting all to false!");

        this.$timeout(() => {
          this.confirmationFilters.all = false;
        }, 1);

        this.confirmationFilterText = "";

        if (this.confirmationFilters.confirmed) {
          this.confirmationFilterText = "CONFIRMED";

          if (this.confirmationFilters.declined) {
            this.confirmationFilterText = "CONFIRMED, DECLINED";
          } else if (this.confirmationFilters.no_response) {
            this.confirmationFilterText = "CONFIRMED, NO RESPONSE";
          }
        } else if (this.confirmationFilters.declined) {
          this.confirmationFilterText = "DECLINED";

          if (this.confirmationFilters.no_response) {
            this.confirmationFilterText = "DECLINED, NO RESPONSE";
          }
        } else if (this.confirmationFilters.no_response) {
          this.confirmationFilterText = "NO RESPONSE";
        }
      }

      if (!this.confirmationFilters.confirmed && !this.confirmationFilters.declined && !this.confirmationFilters.no_response) {
        this.$timeout(() => {
          this.confirmationFilters = {
            all: true,
            confirmed: false,
            declined: false,
            no_response: false,
          };
          this.confirmationFilterText = "ALL";
        }, 1);
      }
    });
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  setAllShiftsView() {
    this.singleShiftView = false;

    this.singleShiftViewId = null;
    this.singleShiftViewShift = null;
    this.singleShiftViewShiftPosition = null;
    this.singleShiftViewFormatted = null;
    this.checkOrUncheckAll(false);
    this.ui.allChecked = false;

    this.$tracking.reportRosterPageClick("all shifts view");

    this.setFakeLoader(750);
  }

  slideToPayment() {
  }

  convertShifts(shifts) {
    return shifts.map((shift) => {
      const timeZone = shift.contactInfo.place.timeZoneId;
      const startTime = moment(shift.timeInterval.startTime);
      const endTime = moment(shift.timeInterval.endTime);
      const startTimeFormatted = startTime.format("h:mm a").toUpperCase();
      const shiftDateFormatted = startTime.format("MMM DD YYYY").toUpperCase();
      const shiftDateFormattedTitle = startTime.format("MMMM Do");
      const shiftStartTimeLoc = startTime.tz(timeZone).format("hh:mm a");
      const shiftEndTimeLoc = endTime.tz(timeZone).format("hh:mm a");

      const shiftTZ = endTime.tz(timeZone).zoneAbbr();

      const shiftEnded = endTime - moment() < 0;
      const shiftStarted = startTime - moment() < 0;
      const shiftLive = shiftStarted && !shiftEnded;

      const diffTime = endTime.diff(startTime);
      const durTime = moment.duration(diffTime);

      const durDays = durTime.days();
      const durHours = 24 * durDays + durTime.hours();
      const durMin = durTime.minutes();

      const duration = `${durHours ? durHours + " hour" : ""}${durHours > 1 ? "s" : ""}${durMin && durMin ? " " : ""}${
        durMin ? durMin + " minutes" : ""
      }`;

      return {
        id: shift.id,
        startDate: startTime.format("MM/DD/YYYY"),
        endDate: endTime.format("MM/DD/YYYY"),
        startTime: startTimeFormatted,
        shiftStartTimeLoc: shiftStartTimeLoc,
        shiftEndTimeLoc: shiftEndTimeLoc,
        shiftDateFormatted,
        endTime: endTime.format("h:mm a").toUpperCase(),
        contactInfo: shift.contactInfo,
        shiftPosition: shift.shiftPosition,
        shiftEnded,
        shiftStarted,
        shiftDateFormattedTitle,
        shiftLive,
        shiftTZ,
        unpaidBreak: shift.unpaidBreak,
        duration,
      };
    });
  }

  getHeader() {
    return ["Last Name", "First Name", "Phone", "Email", "Status", "Start Date", "End Date", "Check in", "Check out", "Final Time Worked"];
  }

  prepareAllApplicantsCSV(applicants) {
    if (!applicants) {
      return false;
    }
    applicants.sort((a, b) => {
      if (a.humanReadableStatus == b.humanReadableStatus) {
        return 0;
      }
      return a.humanReadableStatus > b.humanReadableStatus ? 1 : -1;
    });
    let csv = [];
    this.csv = [];

    try {
      applicants.forEach((applicant, i) => {
        if (applicant.humanReadableStatus === "Hired") {
          let shift;
          if (
            this.shiftConfirmationData &&
            this.shiftConfirmationData[this.singleShiftViewShiftPosition] &&
            this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId]
          ) {
            shift = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId];
          }

          if (!shift) {
            return;
          }

          let finalTimeWorked;
          let now = moment();
          let shiftEndTimeMoment = moment(shift.timeInterval.endTime);
          let differenceBetweenNowAndEndTime = now.diff(shiftEndTimeMoment, "mintues");

          if (differenceBetweenNowAndEndTime >= 0 || shift.actualMinutesWorked) {
            finalTimeWorked =
              shift && shift.actualMinutesWorked
                ? shift.timeInterval.timeInHours + " hours " + shift.timeInterval.timeInMinutes + " minutes"
                : this.singleShiftViewShift.duration;
          } else {
            finalTimeWorked = "--";
          }

          finalTimeWorked = "--";

          let csvObj = {
            lastName: `${applicant.applicantLastName}`,
            firstName: ` ${applicant.applicantFirstName}`,
            phone: applicant.applicantHomeContactInfo.phoneMobile,
            email: applicant.applicantEmail,
            status: applicant.humanReadableStatus,
            startDate: this.singleShiftViewShift.startDate + " " + this.singleShiftViewShift.startTime,
            endDate: this.singleShiftViewShift.endDate + " " + this.singleShiftViewShift.endTime,
            checkIn: shift && shift.checkInTimeOnly ? shift.checkInTimeOnly : "",
            checkOut: shift && shift.checkOutTimeOnly ? shift.checkOutTimeOnly : "",
            duration: finalTimeWorked,
          };
          csv.push(csvObj);
        }
      });
    } catch (err) {
      console.log("error processing csv");
      console.dir(err);
    } finally {
      this.csv = csv;
      //this.unSetLoader();
    }
  }

  setStatus(status) {
    if (!status || status === 3) return "Pending";

    if (status === 1) return "Hired";

    if (status === 2) return "Rejected";

    if (status === 4) return "Quit";

    if (status === 5) return "Withdrawn";

    if (status === 6) return "Abandoned";

    if (status === 7) return "Canceled";
  }

  clearSearch() {
    this.jobQuery = "";
    this.$tracking.reportRosterPageClick("clear search");
    this.reloadApplicants();
  }

  reloadApplicants(loading) {
    const jobblePoolId = this.event.subEvents[0].deduppedJobbles[0].jobblePoolId;
    this.loadAllApplicants(jobblePoolId, loading);
  }

  setSortOrder(sort) {
    if (sort === "confirmation") {
      return;
    }

    this.sortOrder = sort === this.sortField ? (this.sortOrder === "desc" ? "asc" : "desc") : "asc";
    this.sortField = sort;

    this.reloadApplicants(true);
  }

  initializeMap() {
    this.reSortHired(true, true);

    this.enableToolTips();

    let mapBoxKey = this.$env.EnvironmentConfig.mapbox;
    mapboxgl.accessToken = mapBoxKey;

    const shift = this.singleShiftViewShift;

    console.log("single shift view", shift);

    let zip = shift.contactInfo.zipCode;
    let street = shift.contactInfo.streetLine1;
    let city = shift.contactInfo.city;
    let state = shift.contactInfo.state;

    let location = street + " " + city + ", " + state + " " + zip;

    var mapboxClient = mapboxSdk({accessToken: mapboxgl.accessToken});

    mapboxClient.geocoding
      .forwardGeocode({
        query: location,
        autocomplete: false,
        limit: 1,
      })
      .send()
      .then((response) => {
        if (response && response.body && response.body.features && response.body.features.length) {
          const feature = response.body.features[0];

          var map = new mapboxgl.Map({
            container: "mapbox-2",
            style: "mapbox://styles/mapbox/streets-v11",
            center: feature.center,
            zoom: 10,
          });

          map.on("load", () => {
            map.addSource("source_circle_500", {
              type: "geojson",
              data: {
                type: "FeatureCollection",
                features: [
                  {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: feature.center,
                    },
                  },
                ],
              },
            });

            const metersToPixelsAtMaxZoom = (meters, latitude) => meters / 0.075 / Math.cos((latitude * Math.PI) / 180);

            map.addLayer({
              id: "circle500",
              type: "circle",
              source: "source_circle_500",
              paint: {
                "circle-radius": {
                  stops: [
                    [0, 0],
                    [20, metersToPixelsAtMaxZoom(METER_RADIUS, feature.center[1])],
                  ],
                  base: 2,
                },
                "circle-color": CIRCLE_COLOR,
                "circle-opacity": CIRCLE_OPACITY,
              },
            });
          });

          let options = {};

          options.color = "#62C046";
          options.scale = 1.5;
          options.anchor = "center";

          let popUpText2 = `<div>${street}</div><div>${city}, ${state} ${zip}</div>`;

          new mapboxgl.Marker(options).setLngLat(feature.center).setPopup(new mapboxgl.Popup().setHTML(popUpText2)).addTo(map);

          this.map = map;

          this.hiredApplicants.map((applicant) => {
            if (
              !this.shiftConfirmationData ||
              !this.shiftConfirmationData[this.singleShiftViewShiftPosition] ||
              !this.shiftConfirmationData[this.singleShiftViewShiftPosition]
            )
              return console.warn("Confirmation Data not loaded for shift");

            const confirmationData = this.shiftConfirmationData[this.singleShiftViewShiftPosition];

            if (!confirmationData[applicant.applicantId]) return console.warn("Confirmation Data not loaded for applicant");

            const applicantConfirmationData = confirmationData[applicant.applicantId];

            if (
              applicantConfirmationData.checkInCoord &&
              applicantConfirmationData.checkInCoord.lng &&
              applicantConfirmationData.checkInCoord.lat &&
              applicantConfirmationData.checkOutCoord &&
              applicantConfirmationData.checkOutCoord.lng &&
              applicantConfirmationData.checkOutCoord.lat &&
              this.getDistanceFromLatLonInM(
                applicantConfirmationData.checkInCoord.lat,
                applicantConfirmationData.checkInCoord.lng,
                applicantConfirmationData.checkOutCoord.lat,
                applicantConfirmationData.checkOutCoord.lng
              ) < METER_THRESHOLD
            ) {
              console.log("THESE ARE CLOSE ENOUGH~");

              let options = {};

              let el = document.createElement("div");

              const dist = this.getDistanceFromLatLonInM(
                applicantConfirmationData.checkInCoord.lat,
                applicantConfirmationData.checkInCoord.lng,
                feature.center[1],
                feature.center[0]
              );
              console.log("check in coordinate dist", dist);

              el.className = "marker";
              el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
              el.style.width = "35px";
              el.style.height = "53px"; // 1.53
              el.style.backgroundSize = "100%";
              el.style.backgroundRepeat = "no-repeat";

              let note = applicantConfirmationData.jobblerNote || "--";

              options.color = "#000";

              let popUpText =
                "<div>" +
                "<div>" +
                applicant.applicantFirstName +
                " " +
                applicant.applicantLastName +
                "</div>" +
                "</div>" +
                "<div class='note-holder'>Check-in: " +
                applicantConfirmationData.checkInTimeOnly +
                "</div>" +
                "<div class='note-holder'>Check-out: " +
                applicantConfirmationData.checkOutTimeOnly +
                "</div>" +
                "<div>Note: " +
                note +
                "</div>";

              let currentMarker = new mapboxgl.Marker(el)
                .setLngLat([applicantConfirmationData.checkInCoord.lng, applicantConfirmationData.checkInCoord.lat])
                .setPopup(new mapboxgl.Popup().setHTML(popUpText))
                .addTo(this.map);
            } else {
              if (
                applicantConfirmationData.checkInCoord &&
                applicantConfirmationData.checkInCoord.lng &&
                applicantConfirmationData.checkInCoord.lat
              ) {
                let options = {};

                let el = document.createElement("div");

                const dist = this.getDistanceFromLatLonInM(
                  applicantConfirmationData.checkInCoord.lat,
                  applicantConfirmationData.checkInCoord.lng,
                  feature.center[1],
                  feature.center[0]
                );
                console.log("check in coordinate dist", dist);

                el.className = "marker";
                el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
                el.style.width = "35px";
                el.style.height = "53px"; // 1.53
                el.style.backgroundSize = "100%";
                el.style.backgroundRepeat = "no-repeat";

                let note = applicantConfirmationData.jobblerNote || "--";

                options.color = "#000";

                let popUpText =
                  "<div><div>" +
                  applicant.applicantFirstName +
                  " " +
                  applicant.applicantLastName +
                  "</div></div><div class='note-holder'>Check-in: " +
                  applicantConfirmationData.checkInTimeOnly +
                  "</div><div>Note: " +
                  note +
                  "</div>";
                let currentMarker = new mapboxgl.Marker(el)
                  .setLngLat([applicantConfirmationData.checkInCoord.lng, applicantConfirmationData.checkInCoord.lat])
                  .setPopup(new mapboxgl.Popup().setHTML(popUpText))
                  .addTo(this.map);
              }

              if (
                applicantConfirmationData.checkOutCoord &&
                applicantConfirmationData.checkOutCoord.lng &&
                applicantConfirmationData.checkOutCoord.lat
              ) {
                let options = {};

                let el = document.createElement("div");

                const dist = this.getDistanceFromLatLonInM(
                  applicantConfirmationData.checkOutCoord.lat,
                  applicantConfirmationData.checkOutCoord.lng,
                  feature.center[1],
                  feature.center[0]
                );
                console.log("check in coordinate dist", dist);

                el.className = "marker";
                el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
                el.style.width = "35px";
                el.style.height = "53px"; // 1.53
                el.style.backgroundSize = "100%";
                el.style.backgroundRepeat = "no-repeat";

                let note = applicantConfirmationData.jobblerNote || "--";

                options.color = "#000";

                let popUpText =
                  "<div><div>" +
                  applicant.applicantFirstName +
                  " " +
                  applicant.applicantLastName +
                  "</div></div><div class='note-holder'>Check-out: " +
                  applicantConfirmationData.checkOutTimeOnly +
                  "</div><div>Note: " +
                  note +
                  "</div>";
                let currentMarker = new mapboxgl.Marker(el)
                  .setLngLat([applicantConfirmationData.checkOutCoord.lng, applicantConfirmationData.checkOutCoord.lat])
                  .setPopup(new mapboxgl.Popup().setHTML(popUpText))
                  .addTo(this.map);
              }
            }
          });
        } else {
          alert("There was an error finding the location of the job.");
        }
        this.$timeout(() => {
          //this.unSetLoader();
        }, 1000);
      });
  }

  getDistanceFromLatLonInM(lat1, lon1, lat2, lon2) {
    const deg2rad = (deg) => {
      return deg * (Math.PI / 180);
    };

    let R = 6371; // Radius of the earth in km
    let dLat = deg2rad(lat2 - lat1); // deg2rad below
    let dLon = deg2rad(lon2 - lon1);
    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in km
    return d * 1000;
  }

  loadMap(lat, lng, shift, contactInfo, applicant, init) {
    let mapBoxKey = this.$env.EnvironmentConfig.mapbox;
    mapboxgl.accessToken = mapBoxKey;

    const feature = {
      center: [lng, lat],
    };

    let map = this.checkinoutmap;

    if (init) {
      map = new mapboxgl.Map({
        container: "check-in-out-map",
        style: "mapbox://styles/mapbox/streets-v11",
        center: feature.center,
        zoom: 10,
      });

      map.on("load", () => {
        map.resize();

        map.addSource("source_circle_500", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: feature.center,
                },
              },
            ],
          },
        });

        const metersToPixelsAtMaxZoom = (meters, latitude) => meters / 0.075 / Math.cos((latitude * Math.PI) / 180);

        map.addLayer({
          id: "circle500",
          type: "circle",
          source: "source_circle_500",
          paint: {
            "circle-radius": {
              stops: [
                [0, 0],
                [20, metersToPixelsAtMaxZoom(METER_RADIUS, feature.center[1])],
              ],
              base: 2,
            },
            "circle-color": CIRCLE_COLOR,
            "circle-opacity": CIRCLE_OPACITY,
          },
        });
      });

      this.checkinoutmap = map;
    }

    console.log("shift for map", shift);

    shift.contactInfo = shift.contactInfo || contactInfo || {};

    let zip = shift.contactInfo.zipCode || "";
    let street = shift.contactInfo.streetLine1 || "";
    let city = shift.contactInfo.city || "";
    let state = shift.contactInfo.state || "";

    let popUpText2 = `<div>${street}</div><div>${city}, ${state} ${zip}</div>`;

    if (this.currentModalLocationMarker && this.currentModalLocationMarker.remove) {
      this.currentModalLocationMarker.remove();
    }

    if (this.currentModalCheckinMarker && this.currentModalCheckinMarker.remove) {
      this.currentModalCheckinMarker.remove();
    }

    if (this.currentModalCheckoutMarker && this.currentModalCheckoutMarker.remove) {
      this.currentModalCheckoutMarker.remove();
    }

    if (!(shift.checkInCoord && shift.checkInCoord.lng) && !(shift.checkOutCoord && shift.checkOutCoord.lng)) {
      let options = {};

      let el = document.createElement("div");

      el.className = "marker";
      el.style.backgroundImage = "url(/app/vendor/images/no-location-icon.png)";
      el.style.width = "35px";
      el.style.height = "53px"; // 1.53
      el.style.backgroundSize = "100%";
      el.style.backgroundRepeat = "no-repeat";

      let note = shift.jobblerNote || "--";

      options.color = "#000";

      let popUpText = `<div>Missing Location Data</div><div>${street}</div><div>${city}, ${state} ${zip}</div>`;

      this.currentModalLocationMarker = new mapboxgl.Marker(el)
        .setLngLat(feature.center)
        .setPopup(new mapboxgl.Popup().setHTML(popUpText))
        .addTo(map);
    } else {
      let options = {};

      options.color = "#62C046";
      options.scale = 1.5;
      options.anchor = "center";

      this.currentModalLocationMarker = new mapboxgl.Marker(options)
        .setLngLat(feature.center)
        .setPopup(new mapboxgl.Popup().setHTML(popUpText2))
        .addTo(map);
    }

    if (
      shift.checkInCoord &&
      shift.checkInCoord.lng &&
      shift.checkInCoord.lat &&
      shift.checkOutCoord &&
      shift.checkOutCoord.lng &&
      shift.checkOutCoord.lat &&
      this.getDistanceFromLatLonInM(shift.checkInCoord.lat, shift.checkInCoord.lng, shift.checkOutCoord.lat, shift.checkOutCoord.lng) <
      METER_THRESHOLD
    ) {
      console.log("THESE ARE CLOSE ENOUGH~");

      let options = {};

      let el = document.createElement("div");

      const dist = this.getDistanceFromLatLonInM(shift.checkInCoord.lat, shift.checkInCoord.lng, feature.center[1], feature.center[0]);
      console.log("check in coordinate dist", dist);

      el.className = "marker";
      el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
      el.style.width = "35px";
      el.style.height = "53px"; // 1.53
      el.style.backgroundSize = "100%";
      el.style.backgroundRepeat = "no-repeat";

      let note = shift.jobblerNote || "--";

      options.color = "#000";

      let popUpText =
        "<div>" +
        "<div>" +
        applicant.applicantFirstName +
        " " +
        applicant.applicantLastName +
        "</div>" +
        "</div>" +
        "<div class='note-holder'>Check-in: " +
        shift.checkInTimeOnly +
        "</div>" +
        "<div class='note-holder'>Check-out: " +
        shift.checkOutTimeOnly +
        "</div>" +
        "<div>Note: " +
        note +
        "</div>";

      this.currentModalCheckinMarker = new mapboxgl.Marker(el)
        .setLngLat([shift.checkInCoord.lng, shift.checkInCoord.lat])
        .setPopup(new mapboxgl.Popup().setHTML(popUpText))
        .addTo(map);
    } else {
      if (shift.checkInCoord && shift.checkInCoord.lng && shift.checkInCoord.lat) {
        let options = {};

        let el = document.createElement("div");

        const dist = this.getDistanceFromLatLonInM(shift.checkInCoord.lat, shift.checkInCoord.lng, feature.center[1], feature.center[0]);
        console.log("check in coordinate dist", dist);

        el.className = "marker";
        el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
        el.style.width = "35px";
        el.style.height = "53px"; // 1.53
        el.style.backgroundSize = "100%";
        el.style.backgroundRepeat = "no-repeat";

        let note = shift.jobblerNote || "--";

        options.color = "#000";

        let popUpText =
          "<div><div>" +
          applicant.applicantFirstName +
          " " +
          applicant.applicantLastName +
          "</div></div><div class='note-holder'>Check-in: " +
          shift.checkInTimeOnly +
          "</div><div>Note: " +
          note +
          "</div>";

        this.currentModalCheckinMarker = new mapboxgl.Marker(el)
          .setLngLat([shift.checkInCoord.lng, shift.checkInCoord.lat])
          .setPopup(new mapboxgl.Popup().setHTML(popUpText))
          .addTo(map);
      }

      if (shift.checkOutCoord && shift.checkOutCoord.lng && shift.checkOutCoord.lat) {
        let options = {};

        let el = document.createElement("div");

        const dist = this.getDistanceFromLatLonInM(shift.checkOutCoord.lat, shift.checkOutCoord.lng, feature.center[1], feature.center[0]);
        console.log("check in coordinate dist", dist);

        el.className = "marker";
        el.style.backgroundImage = dist > METER_RADIUS ? RED_ICON : GREEN_ICON;
        el.style.width = "35px";
        el.style.height = "53px"; // 1.53
        el.style.backgroundSize = "100%";
        el.style.backgroundRepeat = "no-repeat";

        let note = shift.jobblerNote || "--";

        options.color = "#000";

        let popUpText =
          "<div><div>" +
          applicant.applicantFirstName +
          " " +
          applicant.applicantLastName +
          "</div></div><div class='note-holder'>Check-out: " +
          shift.checkOutTimeOnly +
          "</div><div>Note: " +
          note +
          "</div>";

        this.currentModalCheckoutMarker = new mapboxgl.Marker(el)
          .setLngLat([shift.checkOutCoord.lng, shift.checkOutCoord.lat])
          .setPopup(new mapboxgl.Popup().setHTML(popUpText))
          .addTo(map);
      }
    }
  }

  setApplicantStatus(shift, shiftPaid, checkInTime, checkOutTime, confirmationResponse) {
    //console.log("setApplicantStatus shift:", shift);
    //console.log("setApplicantStatus shift:", shiftPaid, checkInTime, checkOutTime, confirmationResponse);
    let status = "";
    let statusNumber = 0;
    let groupNumber = 0;
    let paymentScore = shift.paymentScore;
    //console.log("PAYMENT SCORE: " + paymentScore);
    if (paymentScore != null) {
      if (shiftPaid) {
        status = "Paid";
        if (shift.noShow) {
          status = "No show, Paid";
        }
        statusNumber = 4;
        groupNumber = 1;
      } else if (shift.noShow) {
        status = "No Show";
        statusNumber = 5;
        groupNumber = 2;
      } else if (shift.actualMinutesWorked > 0) {
        status = "Ready to pay";
        statusNumber = 1;
        groupNumber = 1;
      } else if (paymentScore >= 0 && paymentScore <= 2) {
        status = "Needs Review";
        statusNumber = 2;
        groupNumber = 2;
      } else if (paymentScore >= 3 && paymentScore <= 5) {
        status = "Needs Review";
        statusNumber = 2;
        groupNumber = 2;
      } else if (paymentScore > 5) {
        status = "Ready to Pay";
        statusNumber = 1;
        groupNumber = 1;
      }
    } else {
      //console.log("IN THE ELSE :");
      //console.dir(shift);
      if (shiftPaid) {
        status = "Paid";
        statusNumber = 4;
        groupNumber = 1;
      } else if (shift.noShow) {
        status = "No Show";
        statusNumber = 5;
        groupNumber = 2;
      } else if ((checkInTime && checkOutTime) || shift.actualMinutesWorked > 0) {
        status = "Ready to pay";
        statusNumber = 1;
        groupNumber = 1;
      } else if (checkInTime || checkOutTime) {
        //status = "No check-" + (checkInTime ? "out" : "in")
        status = "Needs review";
        statusNumber = 2;
        groupNumber = 2;
      } else {
        status = "Needs review";
        statusNumber = 3;
        groupNumber = 2;
      }
    }

    if (confirmationResponse) {
      groupNumber = 1;
    }

    return {status, statusNumber, groupNumber};
  }

  loadSingleShiftConfirmationData(shiftId, shiftPosition, overallShift) {
    console.log("loadSingleShiftConfirmationData");
    //console.dir(shiftId);
    //console.dir(overallShift);

    this.$timeout(() => {
      this.loadingShiftConfirmationDataByShift[shiftId] = true;
    });
    this.setLoader();
    this.$events.getShiftsInSamePosition(shiftId).then((data) => {
      console.log("getShiftsInSamePosition");
      console.dir(data);

      this.$timeout(() => {
        this.loadingShiftConfirmationDataByShift[shiftId] = false;
      });

      const applicationData = data.data;

      //console.log("applicationData");
      //console.dir(applicationData);

      const payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
      //const payPerHour = this.event.subEvents[0].deduppedJobbles[0].payPerHour;
      //const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
      const payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

      applicationData.forEach((shift) => {

        const {applicant} = shift;

        if (!applicant) return;

        const applicantId = applicant.id;

        //console.log(shiftId, shiftPosition, applicantId);

        //console.log("real shift id", shiftId, shift.id);

        //console.log("shift id info--");
        //console.dir(shift.id);
        //console.dir(shift.checkInTime);

        const confirmationResponse = shift.confirmationResponse || null;
        const confirmationResponseExists = shift.confirmationResponse !== null;
        const jobblerNote = shift.jobblerNote;
        let checkInTime = shift.checkInTime || null;
        let checkOutTime = shift.checkOutTime || null;
        let checkInTimeOnly = null;
        let checkOutTimeOnly = null;
        let manualCheckInTime = shift.manualCheckInTime || null;
        let manualCheckOutTime = shift.manualCheckOutTime || null;
        let manualCheckInTimeOnly = null;
        let manualCheckOutTimeOnly = null;

        let shiftPaid = !!(shift.paymentStats && shift.paymentStats.amountRecievedByJobber);

        let checkInTimeMoment;
        let checkOutTimeMoment;
        let manualCheckInTimeMoment;
        let manualCheckOutTimeMoment;
        let payment;
        let paymentJobbler;
        let paymentJobblerNoFee;
        let hoursRounded = null;
        let momentET = null;
        let momentST = null;
        let totalMinutes = null;
        let minutesMod = null;
        let jobblerScheduleManagementStatus;
        let timeZone = shift.contactInfo.place.timeZoneId;

        shift.TZ = moment.tz(timeZone).zoneAbbr();

        if (checkInTime) {

          checkInTimeMoment = moment.tz(checkInTime, timeZone);
          checkInTimeMoment = checkInTimeMoment.seconds() < 30 ? checkInTimeMoment.startOf('minute') : checkInTimeMoment.startOf('minute').add(1, 'minute');
          //checkInTimeMoment = moment(checkInTime);
          checkInTime = checkInTimeMoment.format("MMM DD, h:mm a").toUpperCase();
          checkInTimeOnly = checkInTimeMoment.format("h:mm A");
          //let checkInTimeMomentNew = this.formatCheckInTime(checkInTime, shift.timeInterval.startTime, shift);
          //checkInTime = checkInTimeMomentNew.format("MMM DD, h:mm a").toUpperCase();
          //checkInTimeOnly = checkInTimeMomentNew.format("h:mm A");
        }

        if (checkOutTime) {
          checkOutTimeMoment = moment.tz(checkOutTime, timeZone);
          checkOutTimeMoment = checkOutTimeMoment.seconds() < 30 ? checkOutTimeMoment.startOf('minute') : checkOutTimeMoment.startOf('minute').add(1, 'minute');
          checkOutTime = checkOutTimeMoment.format("MMM DD, h:mm a").toUpperCase();
          checkOutTimeOnly = checkOutTimeMoment.format("h:mm A");
          //let checkOutTimeMomentNew = this.formatCheckOutTime(checkOutTime, shift);
          //checkOutTime = checkOutTimeMomentNew.format("MMM DD, h:mm a").toUpperCase();
          //checkOutTimeOnly = checkOutTimeMomentNew.format("h:mm A");
        }

        if (manualCheckInTime) {
          manualCheckInTimeMoment = moment.tz(manualCheckInTime, timeZone);
          manualCheckInTimeMoment = manualCheckInTimeMoment.seconds() < 30 ? manualCheckInTimeMoment.startOf('minute') : manualCheckInTimeMoment.startOf('minute').add(1, 'minute');
          manualCheckInTime = manualCheckInTimeMoment.format("MMM DD, h:mm a").toUpperCase();
          manualCheckInTimeOnly = manualCheckInTimeMoment.format("h:mm A");
        }

        if (manualCheckOutTime) {
          manualCheckOutTimeMoment = moment.tz(manualCheckOutTime, timeZone);
          manualCheckOutTimeMoment = manualCheckOutTimeMoment.seconds() < 30 ? manualCheckOutTimeMoment.startOf('minute') : manualCheckOutTimeMoment.startOf('minute').add(1, 'minute');
          manualCheckOutTime = manualCheckOutTimeMoment.format("MMM DD, h:mm a").toUpperCase();
          manualCheckOutTimeOnly = manualCheckOutTimeMoment.format("h:mm A");
        }

        let {
          status,
          statusNumber,
          groupNumber
        } = this.setApplicantStatus(shift, shiftPaid, checkInTime, checkOutTime, confirmationResponse);

        /*
         * We look for:
         * 1. Manager edited hours first
         * 2. Jobbler manual check out second
         * 3. Default checkin and out values 3rd
         * 4. Lastly default to 0 total hours to prompt editing
         */

        if (shift.actualMinutesWorked !== null) {
          totalMinutes = shift.actualMinutesWorked;
          shift.totalMinutes = totalMinutes;
        } else if (shift.manualCheckOutTime !== null) {

          momentET = manualCheckOutTimeMoment;

          if (shift.manualCheckInTime !== null) {
            momentST = manualCheckInTimeMoment;
          } else if (shift.checkInTime !== null) {
            momentST = checkInTimeMoment;
          } else {
            momentST = moment.tz(shift.timeInterval.startTime, timeZone);
            //momentST = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId);
          }

          totalMinutes = momentET.diff(momentST, "minutes");

          if (overallShift.unpaidBreak > totalMinutes) {
            shift.totalMinutes = totalMinutes;
          } else {
            shift.totalMinutes = totalMinutes - overallShift.unpaidBreak;
          }
        } else if (shift.manualCheckInTime !== null) {
          momentST = manualCheckInTimeMoment;

          if (shift.manualCheckOutTime !== null) {
            momentET = manualCheckOutTimeMoment;
          } else if (shift.checkOutTime !== null) {
            momentET = checkOutTimeMoment;
          } else {
            momentET = moment.tz(shift.timeInterval.endTime, timeZone);
          }

          totalMinutes = moment(momentET).diff(moment(momentST), "minutes");

          if (overallShift.unpaidBreak > totalMinutes) {
            shift.totalMinutes = totalMinutes;
          } else {
            shift.totalMinutes = totalMinutes - overallShift.unpaidBreak;
          }
        } else if (checkInTime !== null && checkOutTime !== null) {

          momentET = checkOutTimeMoment.tz(shift.contactInfo.place.timeZoneId);
          momentST = checkInTimeMoment.tz(shift.contactInfo.place.timeZoneId);
          totalMinutes = moment(checkOutTime).diff(moment(checkInTime), "minutes");

          if (overallShift.unpaidBreak > totalMinutes) {
            shift.totalMinutes = totalMinutes;
          } else {
            shift.totalMinutes = totalMinutes - overallShift.unpaidBreak;
          }
        } else {
          totalMinutes = 0;
          shift.totalMinutes = 0;
          shift.originalTotalMinutes = 0;
        }

        hoursRounded = Math.floor(shift.totalMinutes / 60);
        minutesMod = shift.totalMinutes % 60;

        shift.timeInterval.timeInHours = hoursRounded;
        shift.timeInterval.timeInMinutes = minutesMod;

        if (shift.paymentStats.amountRecievedByJobber === null) {
          payment = (Math.round(((shift.totalMinutes * payPerHour) / 100 / 60) * 100) / 100).toFixed(2);
          paymentJobbler = (Math.round(((shift.totalMinutes * payPerHourJobbler) / 100 / 60) * 100) / 100).toFixed(2);
        } else {
          //payment = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
          //paymentJobbler = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
          payment = (shift.paymentStats.amountCompany / 100).toFixed(2);
          paymentJobbler = (shift.paymentStats.amountRecievedByJobber / 100).toFixed(2);

          let a = shift.paymentStats.amountRecievedByJobber;
          let h = a / this.event.subEvents[0].deduppedJobbles[0].payPerHour;
          let a2 = h * payPerHourJobbler;
          paymentJobblerNoFee = (Math.round((a2 / 100) * 100) / 100).toFixed(2);
        }

        //console.log("user.payment", payment);
        //console.log("user.paymentJobbler", paymentJobbler);

        const paymentHours = Math.round((paymentJobbler / (this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100)) * 100) / 100;
        let tooltip;

        let ppr = Math.round(this.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100).toFixed(2);

        if (shift.paymentStats.number === 1) {
          tooltip = `Paid $${paymentJobbler} at $${ppr}/hr`;
        } else if (shift.paymentStats.number > 1) {
          tooltip = `This user was paid ${shift.paymentStats.number} times for this shift for a total of $${paymentJobbler}`;
        } else {
          tooltip = `This users payment is still processing`;
        }
        //console.log("tooltip", tooltip);

        jobblerScheduleManagementStatus = this.calculateJobblerScheduleManagementStatus(shift);

        this.$timeout(() => {
          this.shiftConfirmationData = this.shiftConfirmationData || {};
          this.shiftConfirmationData[shiftPosition] = this.shiftConfirmationData[shiftPosition] || {};
          this.shiftConfirmationData[shiftPosition][applicantId] = {
            shiftId: shift.id,
            shiftPosition,
            applicantId,
            paymentHours,
            checkInTime,
            checkOutTime,
            checkInTimeOnly,
            checkOutTimeOnly,
            checkInTimeMoment,
            checkOutTimeMoment,
            manualCheckInTime,
            manualCheckOutTime,
            manualCheckInTimeOnly,
            manualCheckOutTimeOnly,
            manualCheckInTimeMoment,
            manualCheckOutTimeMoment,
            confirmationResponse,
            jobblerScheduleManagementStatus,
            confirmationResponseExists,
            jobblerNote,
            status,
            tooltip,
            statusNumber,
            TZ: shift.TZ,
            groupNumber,
            checkInCoord: shift.checkInCoord || shift.autoCheckInCoord,
            checkOutCoord: shift.checkOutCoord || shift.autoCheckOutCoord,
            actualMinutesWorked: shift.actualMinutesWorked,
            noShow: shift.noShow,
            paymentStats: shift.paymentStats,
            shiftPaid,
            totalMinutes: shift.totalMinutes,
            originalTotalMinutes: shift.originalTotalMinutes,
            timeInterval: shift.timeInterval,
            payment,
            paymentJobbler,
            paymentJobblerNoFee,
            unpaidBreak: overallShift.unpaidBreak,
            paymentScore: shift.paymentScore,
          };

          //console.log("EACH SHIFT AFTER CONFIRMATION PROCESSING");
          //console.dir

          this.reSortHired();
          this.setConfirmationNumbers();
          this.processWhoCanBePaid();

          this.$timeout(() => {
            this.unSetLoader();
          }, 500);

        });
      });

      this.enableToolTips();
    });
  }

  calculateJobblerScheduleManagementStatus(shift) {
    let result;

    if (shift) {
      if (shift.confirmationResponse === true) {
        result = "Confirmed";
      } else if (shift.confirmationResponse === false) {
        result = "Declined";
      }

      if (shift.leavingEarly === true) {
        result = "Leaving " + shift.leavingEarlyTime + " mins early";
      }

      if (shift.stayingLate === true) {
        result = "Staying late";
      }

      if (shift.runningLate === true) {
        result = "Running " + shift.runningLateTime + " mins late";
      }

      if (shift.calledOut === true) {
        result = "Called out";
      }
    } else {
      result = "--";
    }

    return result;
  }

  checkForUnconfirmedList() {
    let unconfirmed = [];

    try {
      if (this.hiredApplicants) {
        if (this.hiredApplicants.length > 0) {
          /*
                    this.hiredApplicants.forEach((a) => {
                        let confirmResp = a.shiftData.confirmationResponse;
                        let confirmExist = a.shiftData.confirmationResponseExists;
                        if (confirmResp != true || confirmExist != true) {
                            unconfirmed.push(s.id);
                        }
                    });
                     */
        }
      } else {
        this.unconfirmed = [];
      }
    } catch (err) {
      console.log("error looping");
      console.dir(err);
    } finally {
      if (unconfirmed.length > 0) {
        this.hasShowMoreApplicants = true;
      }
    }
  }

  formatCheckOutTime(checkOutTime, shift) {
    let checkOut = moment(checkOutTime);
    let time;
    let remainder;

    remainder = 15 - (checkOut.minute() % 15);

    if (remainder < 15) {
      time = moment(checkOut).add(remainder, "minutes");
    } else {
      time = checkOut;
    }

    return time;
  }

  formatCheckInTime(checkInTime, shiftStartTime, shift) {
    let checkIn = moment(checkInTime);
    let startTime = moment(shiftStartTime);
    let time;
    let remainder;

    if (checkIn.isBefore(startTime)) {
      time = startTime;
    } else {
      remainder = 15 - (checkIn.minute() % 15);
      time = moment(checkIn).add(remainder, "minutes");
    }

    return time;
  }

  enableToolTips() {
    this.$timeout(() => {
      $(".link-tool-tip").tooltip({}); //.tooltip('dispose');
      $(".payment-tool-tip").tooltip({}).tooltip("fixTitle");
    }, 200);

    this.$timeout(() => {
      $(".bg-check-status-image").tooltip({});
      $(".bg-check-status").tooltip({});
      $(".application-reason").tooltip({});
      $(".overlapp-msg").tooltip({});
      $(".quit-reason").tooltip({});
    }, 300);
  }

  returnToolTip(t) {
    return t;
  }

  returnToolTipAdv(applicant) {
    let message = applicant.applicationErrors[0].errorText;

    if (message.indexOf("jobbleapp.com") !== -1) {
    }

    return "Why did this user not get hired for job? Because: " + applicant.applicationErrors[0].errorText;
  }

  loadShiftConfirmationData(subEventId) {

    console.log("loadShiftConfirmationData");

    this.$timeout(() => {
      this.loadingShiftConfirmationData = true;
    });

    this.$events.getAcceptedApplicationsRosterManagement(subEventId).then((data) => {
      this.$timeout(() => {
        this.loadingShiftConfirmationData = false;
      });

      const applicationData = data.data;
      const payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
      //const payPerHour = this.event.subEvents[0].deduppedJobbles[0].payPerHour;
      // const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
      const payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

      applicationData.forEach((applicationDataObject) => {
        const {
          applicant,
          jobble: {shifts},
        } = applicationDataObject;

        const applicantId = applicant.id;

        shifts.forEach((shift) => {
          console.log("shifts look");
          console.dir(shift.id);

          const confirmationResponse = shift.confirmationResponse || null;
          const confirmationResponseExists = shift.confirmationResponse !== null;
          const shiftPosition = shift.shiftPosition;
          const jobblerNote = shift.jobblerNote;
          const shiftId = shift.id || null;
          let checkInTime = shift.checkInTime || null;
          let checkOutTime = shift.checkOutTime || null;
          let checkInTimeOnly = null;
          let checkOutTimeOnly = null;

          let shiftPaid = !!(shift.paymentStats && shift.paymentStats.amountRecievedByJobber);

          let checkInTimeMoment;
          let checkOutTimeMoment;
          let payment;
          let paymentJobbler;
          let paymentJobblerNoFee;
          let hoursRounded = null;
          let momentET = null;
          let momentST = null;
          let totalMinutes = null;
          let minutesMod = null;

          if (checkInTime) {
            checkInTimeMoment = moment(checkInTime);
            checkInTime = checkInTimeMoment.format("MMM DD, h:mm a").toUpperCase();
            checkInTimeOnly = checkInTimeMoment.format("h:mm A");
          }

          if (checkOutTime) {
            checkOutTimeMoment = moment(checkOutTime);
            checkOutTime = checkOutTimeMoment.format("MMM DD, h:mm a").toUpperCase();
            checkOutTimeOnly = checkOutTimeMoment.format("h:mm A");
          }

          let {
            status,
            statusNumber,
            groupNumber
          } = this.setApplicantStatus(shift, shiftPaid, checkInTime, checkOutTime, confirmationResponse);

          if (shift.actualMinutesWorked !== null) {
            console.log("We have actualMinutes worked data");

            totalMinutes = shift.actualMinutesWorked;
          } else {
            //console.log("no we have actualMinutes worked data");
            //console.dir(shift);
            momentET = moment(shift.timeInterval.endTime).tz("America/New_York");
            momentST = moment(shift.timeInterval.startTime).tz("America/New_York");

            totalMinutes = moment(momentET).diff(moment(momentST), "minutes");
            shift.totalMinutes = totalMinutes;
          }

          hoursRounded = Math.floor(totalMinutes / 60);
          minutesMod = totalMinutes % 60;

          if (shift.paymentStats.amountRecievedByJobber === null) {
            payment = (Math.round(((totalMinutes * payPerHour) / 100 / 60) * 100) / 100).toFixed(2);
            paymentJobbler = (Math.round(((totalMinutes * payPerHourJobbler) / 100 / 60) * 100) / 100).toFixed(2);
          } else {
            //payment = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
            //paymentJobbler = (Math.round((shift.paymentStats.amountRecievedByJobber / 100) * 100) / 100).toFixed(2);
            payment = (shift.paymentStats.amountCompany / 100).toFixed(2);
            paymentJobbler = (shift.paymentStats.amountRecievedByJobber / 100).toFixed(2);

            let a = shift.paymentStats.amountRecievedByJobber;
            let h = a / this.event.subEvents[0].deduppedJobbles[0].payPerHour;
            let a2 = h * payPerHourJobbler;
            paymentJobblerNoFee = (Math.round((a2 / 100) * 100) / 100).toFixed(2);
          }

          console.log("user.payment", payment);
          console.log("user.paymentJobbler", paymentJobbler);
          console.dir((totalMinutes * payPerHour) / 100 / 60);

          shift.totalMinutes = totalMinutes;
          shift.timeInterval.timeInHours = hoursRounded;
          shift.timeInterval.timeInMinutes = minutesMod;

          const paymentHours = Math.round((paymentJobbler / (this.event.subEvents[0].deduppedJobbles[0].payPerHour / 100)) * 100) / 100;
          let tooltip;
          let ppr = Math.round(this.event.subEvents[0].deduppedJobbles[0].jobblerRate / 100).toFixed(2);

          if (shift.paymentStats.number === 1) {
            tooltip = `Paid $${paymentJobbler} at $${ppr}/hr`;
          } else if (shift.paymentStats.number > 1) {
            tooltip = `This user was paid ${shift.paymentStats.number} times for this shift for a total of $${paymentJobbler}`;
          } else {
            tooltip = `This users payment is still processing`;
          }
          //console.log("tooltip", tooltip);

          this.$timeout(() => {
            this.shiftConfirmationData = this.shiftConfirmationData || {};
            this.shiftConfirmationData[shiftPosition] = this.shiftConfirmationData[shiftPosition] || {};
            this.shiftConfirmationData[shiftPosition][applicantId] = {
              shiftId,
              shiftPosition,
              paymentHours,
              applicantId,
              checkInTime,
              checkOutTime,
              checkInTimeOnly,
              checkOutTimeOnly,
              checkInTimeMoment,
              checkOutTimeMoment,
              confirmationResponse,
              confirmationResponseExists,
              jobblerNote,
              status,
              tooltip,
              statusNumber,
              groupNumber,
              checkInCoord: shift.checkInCoord || shift.autoCheckInCoord,
              checkOutCoord: shift.checkOutCoord || shift.autoCheckOutCoord,
              actualMinutesWorked: shift.actualMinutesWorked,
              noShow: shift.noShow,
              paymentStats: shift.paymentStats,
              shiftPaid,
              totalMinutes,
              timeInterval: shift.timeInterval,
              payment,
              paymentJobbler,
              paymentJobblerNoFee,
            };

            this.reSortHired();
            this.setConfirmationNumbers();
            this.processWhoCanBePaid();
          });
        });
      });

      this.$timeout(() => {
        this.initializeMap();
        console.log("this.shiftConfirmationData", this.shiftConfirmationData);
      }, 200);

      this.enableToolTips();
    });
  }

  updateCheckInOutData(shiftPosition, applicantId, checkInTime, checkOutTime, rawMoment) {
    this.$timeout(() => {
      this.shiftConfirmationData = this.shiftConfirmationData || {};
      this.shiftConfirmationData[shiftPosition] = this.shiftConfirmationData[shiftPosition] || {};
      this.shiftConfirmationData[shiftPosition][applicantId] = this.shiftConfirmationData[shiftPosition][applicantId] || {};

      if (checkInTime) {
        this.shiftConfirmationData[shiftPosition][applicantId].checkInTime = checkInTime;
        this.shiftConfirmationData[shiftPosition][applicantId].checkInTimeOnly = rawMoment.format("h:mm A");
        this.shiftConfirmationData[shiftPosition][applicantId].checkInTimeMoment = rawMoment;
      }

      if (checkOutTime) {
        this.shiftConfirmationData[shiftPosition][applicantId].checkOutTime = checkOutTime;
        this.shiftConfirmationData[shiftPosition][applicantId].checkOutTimeOnly = rawMoment.format("h:mm A");
        this.shiftConfirmationData[shiftPosition][applicantId].checkOutTimeMoment = rawMoment;
      }

      const {shiftPaid} = this.shiftConfirmationData[shiftPosition][applicantId];

      let {status, statusNumber, groupNumber} = this.setApplicantStatus(
        this.shiftConfirmationData[shiftPosition][applicantId],
        shiftPaid,
        this.shiftConfirmationData[shiftPosition][applicantId].checkInTime,
        this.shiftConfirmationData[shiftPosition][applicantId].checkOutTime,
        this.shiftConfirmationData[shiftPosition][applicantId].confirmationResponse
      );

      this.shiftConfirmationData[shiftPosition][applicantId].status = status;
      this.shiftConfirmationData[shiftPosition][applicantId].statusNumber = statusNumber;
      this.shiftConfirmationData[shiftPosition][applicantId].groupNumber = groupNumber;

      console.log(this.shiftConfirmationData[shiftPosition][applicantId]);
    });
  }

  updateNoShowValue(shiftPosition, applicantId, noShow, actualMinutesWorked) {
    this.$timeout(() => {
      this.shiftConfirmationData = this.shiftConfirmationData || {};
      this.shiftConfirmationData[shiftPosition] = this.shiftConfirmationData[shiftPosition] || {};
      this.shiftConfirmationData[shiftPosition][applicantId] = this.shiftConfirmationData[shiftPosition][applicantId] || {};
      this.shiftConfirmationData[shiftPosition][applicantId].noShow = noShow;

      if (noShow) {
        this.shiftConfirmationData[shiftPosition][applicantId].actualMinutesWorked = actualMinutesWorked;
      }

      const {
        shiftPaid,
        checkInTime,
        checkOutTime,
        confirmationResponse
      } = this.shiftConfirmationData[shiftPosition][applicantId];

      let {status, statusNumber, groupNumber} = this.setApplicantStatus(
        this.shiftConfirmationData[shiftPosition][applicantId],
        shiftPaid,
        checkInTime,
        checkOutTime,
        confirmationResponse
      );

      this.shiftConfirmationData[shiftPosition][applicantId].status = status;
      this.shiftConfirmationData[shiftPosition][applicantId].statusNumber = statusNumber;
      this.shiftConfirmationData[shiftPosition][applicantId].groupNumber = groupNumber;

      this.processWhoCanBePaid();
      this.reSortHired();
    });
  }

  uncheckPaymentInfo(card) {
    this.paymentInfos.forEach((info) => {
      if (card && card.cardToken === info.cardToken) return;

      info.isChecked = false;
    });
  }

  setCardToPayment(data) {
    console.log("setCardToPayment");
    console.dir(data);

    let req = {};

    this.uncheckPaymentInfo(data);

    if (data.isChecked === true) {
      data.isChecked = false;
      req.card = null;
      this.selectedCard = null;
    } else {
      data.isChecked = true;
      if (!data.cardToken) {
        req.bank = data.stripeId;
        this.selectedCard = data.stripeId;
      } else {
        req.card = data.cardToken;
        this.selectedCard = data.cardToken;
      }
    }

    this.transferData = req;
  }

  populateCardImage(info) {
    if (info.cardBrand === "American Express") {
      info.image = "fa fa-cc-amex";
    }
    if (info.cardBrand === "Visa") {
      info.image = "fa fa-cc-visa";
    }
    if (info.cardBrand === "Discover") {
      info.image = "fa fa-cc-discover";
    }
    if (info.cardBrand === "MasterCard") {
      info.image = "fa fa-cc-mastercard";
    }

    if (info.bankName) {
      info.image = "fas fa-university";
    }

    return info.image;
  }

  organizePaymentOptions(user) {
    const _this = this;

    let paymentOptions = [];
    let paymentOptionsUnverified = [];

    if (this.currentUser.company.payByInvoice === true || this.currentUser.company.defaultPlan.requiresSubscription === true) {
      this.paymentInfos = [];
      this.unverifedPaymentInfos = [];
      this.banks = [];
      this.invoice = true;
    } else {
      this.invoice = false;

      try {
        if (user.company.undeletedPaymentInfos) {
          user.company.undeletedPaymentInfos.forEach((info) => {
            info.image = this.populateCardImage(info);

            if (info.bankName === null) {
              console.log("here is the card... card: ", info);

              paymentOptions.push(info);
            } else {
              console.log("here is the bank... bank: ", info);

              if (info.validated === true) {
                info.cardBrand = info.bankName;
                paymentOptions.push(info);
              } else {
                info.cardBrand = info.bankName;
                paymentOptionsUnverified.push(info);
              }
            }
          });
        }
      } catch (err) {
        console.error("SDD", err);
      } finally {
        console.log("this.paymentInfos after. this.paymentInfos:", paymentOptions);
        console.log("this.paymentInfos after. this.paymentOptionsUnverified:", paymentOptionsUnverified);
        _this.paymentInfos = paymentOptions;
        _this.unverifedPaymentInfos = paymentOptionsUnverified;
        console.log("this.paymentInfos after. this.paymentInfos:", _this.paymentInfos);
      }
    }
  }

  sendAdditionalPayment() {
    if (
      !(
        this.additionalPaymentAmountJobbler > 0.5 &&
        this.atLeastOneReadyToAdditionalPayChecked &&
        ((!this.invoice && this.selectedCard) || this.invoice)
      )
    )
      return;

    let transferArray = [];
    let applicantArray = [];

    if (this.submittingAdditionalPayment) return;

    this.submittingAdditionalPayment = true;

    this.$tracking.reportRosterPageSubmit("payment - submit additional payment");

    jQuery("#modal-additional-payment .modal-header button.close").trigger("click");
    jQuery("#modal-additional-payment-done").modal();

    if (!this.invoice && (!this.transferData || !this.transferData.card || !this.transferData.bank)) {
      alert("Please select a payment method");
      return;
    }

    let transferData = this.transferData || {};

    console.log("New additional data:", transferData);

    try {
      this.readyToAdditionalPaySelected.forEach((applicant) => {
        const shift = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId];

        let data = {};
        // let amount = Math.round(parseFloat(this.additionalPaymentAmount) * 100);
        let amount = Math.round(parseFloat(this.additionalPaymentAmountJobbler) * 100);

        data.recipient = applicant.applicantEmail;

        data.amount = amount;

        if (this.additionalPaymentMemo) {
          data.note = "Additional Payment: " + this.additionalPaymentMemo;
        } else {
          data.note = "Additional Payment";
        }

        data.isAdditionalPayment = true;
        data.shift = shift.shiftId;

        if (!amount) return;

        transferArray.push(data);
        applicantArray.push({
          applicant,
          data,
        });
      });
    } finally {
      console.log("what is the transfer for additional payment array: transferArray", transferArray);

      transferData.transfers = transferArray;

      console.log("final transfer data: transferData", transferData);

      this.$tracking.reportRosterPageSubmit("payment - submit additional payment - " + transferArray.length);

      this.postAdditionalPayment(transferData, applicantArray);
    }
  }

  sendPayment() {
    console.log("sendPayment");
    console.dir(this.readyToPay.length);
    console.dir(this.invoice);
    console.dir(this.selectedCard);

    if (!(this.readyToPay.length && !this.updatingHoursWorked && ((!this.invoice && this.selectedCard) || this.invoice))) return;

    let transferArray = [];
    let applicantArray = [];
    let hoursUpdateList = [];

    this.confirmAllHaveHours();

    if (this.submittingPayment || !this.allHaveHours) return;

    this.submittingPayment = true;

    console.log("submit");

    this.$tracking.reportRosterPageSubmit("payment - submit payment");

    if (!this.invoice && (!this.transferData || !this.transferData.card || !this.transferData.bank)) {
      alert("Please select a payment method");
    }

    let transferData = this.transferData || {};

    console.log("new transget data:", transferData);

    try {
      this.readyToPay.forEach((applicant) => {
        const shift = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId];

        if (shift.totalMinutes && !shift.actualMinutesWorked) {
          console.warn("Need to update shift.actualMinutesWorked for shift id =", shift.shiftId);
          hoursUpdateList.push(shift);
          //this.updateHoursWorked(shift, true);
        }

        let data = {};
        // let amount = Math.round(shift.payment * 100);
        let amount = Math.round(shift.paymentJobbler * 100);

        data.recipient = applicant.applicantEmail;

        data.amount = amount;

        data.note = "Payment";
        data.shift = shift.shiftId;

        if (!amount) return;

        transferArray.push(data);
        applicantArray.push({
          applicant,
          data,
        });
      });
    } finally {
      console.log("what is the transfer array: transferArray", transferArray);

      this.transferArray = transferArray;

      transferData.transfers = transferArray;

      console.log("final transfer data: transferData", transferData);

      this.$tracking.reportRosterPageSubmit("payment - submit payment - " + transferArray.length);

      this.postPayment(transferData, applicantArray, null, hoursUpdateList);
    }
  }

  sendRejectionPayment() {
    if (!((!this.invoice && this.selectedCard) || this.invoice)) return;

    let transferArray = [];
    let applicantArray = [];

    this.confirmAllRejectionsHaveHours();

    if (this.submittingPayment || !this.allRejectionsHaveHours) return;

    this.submittingPayment = true;

    console.log("submitting rejection payment");

    this.$tracking.reportRosterPageSubmit("payment - submit payment");

    if (!this.invoice && (!this.transferData || !this.transferData.card || !this.transferData.bank)) {
      alert("Please select a payment method");
    }

    let transferData = this.transferData || {};

    console.log("new transfer data:", transferData);

    try {
      this.paymentContingenciesShiftPositions.forEach((shiftPosition) => {
        this.paymentContingenciesMap[shiftPosition].forEach((applicant) => {
          const shift = this.shiftConfirmationData[shiftPosition][applicant.applicantId];

          let data = {};
          let amount = Math.round(shift.paymentJobbler * 100);

          data.recipient = applicant.applicantEmail;

          data.amount = amount;

          data.note = "Payment";
          data.shift = shift.shiftId;

          if (!amount) return;

          transferArray.push(data);
          applicantArray.push({
            applicant,
            data,
            shiftPosition,
          });
        });
      });
    } finally {
      console.log("what is the transfer array: transferArray", transferArray);

      this.transferArray = transferArray;

      transferData.transfers = transferArray;

      console.log("final transfer data: transferData", transferData);

      this.$tracking.reportRosterPageSubmit("payment - submit payment - " + transferArray.length);

      this.postPayment(transferData, applicantArray, true);
    }
  }

  postPayment(transferData, applicantArray, rejectionFlow, hoursUpdateList) {
    // this.$timeout(() => { this.loadingShiftConfirmationData = true; });

    this.$events.payUsersByShift(transferData).then(
      (response) => {
        this.submittingPayment = false;

        if (rejectionFlow) {
          jQuery("#modal-rejection-shift-payment .modal-header button.close").trigger("click");
          this.$timeout(() => {
            jQuery("#modal-rejection-confirm").modal({
              backdrop: true,
            });
          }, 100);
        } else {
          jQuery("#modal-shift-payment .modal-header button.close").trigger("click");
          jQuery("#modal-shift-payment-done").modal();
        }

        console.log("response from payUsersByShift", response);

        if ((response.data && response.data.status && response.data.status === "error") || response.data[0].status === "error") {
          this.paymentError = true;
          if (response.data[0]) {
            if (response.data[0].message) {
              this.paymentErrorText = response.data[0].message;
            }
          } else {
            this.paymentErrorText = response.data.message;
          }
        } else {
          this.paymentError = false;

          this.findUsersInTransferAndUpdateUI(applicantArray, rejectionFlow);
          this.reSortHired(true, true);

          this.$timeout(() => {
            this.processWhoCanBePaid();
          });
        }

        this.transferData = {};
        this.paymentList = [];

        this.totalPayment = 0;
        this.totalMinutesWorkedForEntireJob = 0;
        this.additionalMonies = 0;
        this.postPaymentAddHours(hoursUpdateList);
        this.totalPaymentDisplay = 0;
      },
      (error) => {
        if (rejectionFlow) {
          jQuery("#modal-rejection-shift-payment .modal-header button.close").trigger("click");
          this.$timeout(() => {
            jQuery("#modal-rejection-confirm").modal({
              backdrop: true,
            });
          }, 100);
        } else {
          jQuery("#modal-shift-payment .modal-header button.close").trigger("click");
        }

        this.submittingPayment = false;

        console.log("what is the error");
        console.dir(error);

        if (error.status === 500) {
          alert("Our payment system is currently down. No payment was processed. Please contact an admin.");
        } else {
          alert("There was a problem with our payment service. Please contact support.");
        }
      }
    );
  }

  postPaymentAddHours(hoursUpdateList) {
    if (hoursUpdateList && hoursUpdateList.length > 0) {
      this.$timeout(() => {
        hoursUpdateList.forEach((shift) => {
          this.updateHoursWorked(shift, true);
        });
      }, 2000);
    }
  }

  postAdditionalPayment(transferData, applicantArray) {
    this.$events.payUsersByShift(transferData).then(
      (response) => {
        this.submittingAdditionalPayment = false;
        this.additionalPaymentMemo = "";
        console.log("response from payUsersByShift", response);

        this.transferData = {};

        this.additionalPaymentAmount = 0;
        this.additionalPaymentAmountJobbler = 0;
      },
      (error) => {
        this.submittingAdditionalPayment = false;
        this.additionalPaymentMemo = "";

        console.log("what is the error");
        console.dir(error);

        console.log("transfer error, error:", error);
        alert("Error : " + error);
      }
    );
  }

  findUsersInTransferAndUpdateUI(applicants, rejectionFlow) {
    applicants.forEach((obj) => {
      const {data, applicant, shiftPosition} = obj;
      let realShiftPosition = rejectionFlow ? shiftPosition : this.singleShiftViewShiftPosition;
      let shift = this.shiftConfirmationData[realShiftPosition][applicant.applicantId];

      shift.status = "Paid";
      shift.statusNumber = 4;
      shift.paymentStats = data;
      shift.shiftPaid = true;

      this.shiftConfirmationData[realShiftPosition][applicant.applicantId] = shift;
    });
  }

  loadAllApplicants(jobblePoolId, loading, eventResp, subEventId) {
    this.lastJobQuery = this.jobQuery + "";

    if (loading) {
      this.setLoader();
    }

    this.$events.getAllApplicants(jobblePoolId, 20, 0, this.sortField, this.sortOrder, this.jobQuery).then(
      (allApplications) => {
        if (loading) {
          this.$timeout(() => {
            this.initialLoadingApplicants = false;
            console.log("DONE LOADING APPS");
          });
        }

        console.log("allApplications");
        console.dir(allApplications);

        this.allApplicantsDoneLoading = true;

        if (allApplications.data.applicants.length !== 0) {
          let applications = [];

          if (allApplications.data.status === "error") {
            alert("Error loading all Applications.");
          } else {
            try {
              applications = allApplications.data.applicants.map((application, i) => {
                application.applicant = application;
                application.whyWasJobblerRemovedFromJob = this.processRejectionReason(application.applicant.applicationStatusReasons);
                application.humanReadableStatus = this.setStatus(application.applicationStatus);
                application.humanReadableQuitReason = this.formatQuitReason(application.applicant.quitReason);
                application.hasBeenSelected = false;
                application.isHireSelected = false;
                application.isHireSelectedLast = false;
                application.renderPhoto = application.applicant.filePROFILE_IMAGE1IMG_75x75;
                application.renderPhotoThumb = application.applicant.filePROFILE_IMAGE1IMG_75x75;
                application = this.setJobblerRatingNew(application);
                application = this.getPaymentInfoPendingNew(application);
                application = this.fixApplicantPhoneNew(application);
                application = this.fixApplicantNameNew(application);
                return application;
              });
            } catch (err) {
              console.log("error looping applicants");
              console.log(err);
            } finally {
              this.busy = false;
              let len = allApplications.data.length;
              //this.setLoader();
              if (len === 20) {
              } else {
                this.busy = false;
                this.pendingApplicants = applications;
                this.allApplicants = applications;
                this.hiredApplicants = this.filterHired(applications);
                this.removedApplicants = this.filterRemoved(applications);
                this.hiredApplicants = this.sortHired(this.hiredApplicants);
                this.setCounts(applications);
                this.setConfirmationNumbers();
                this.prepareAllApplicantsCSV(applications);
                this.checkForOverLaps();
                this.checkForAtleastOneCheckedApplicant();
                this.processShifts(eventResp);
              }
            }
          }
        } else {
          this.pendingApplicants = [];
          this.allApplicants = [];
          this.hiredApplicants = [];
          this.processShifts(eventResp);
          this.$timeout(() => {
            this.unSetLoader();
          }, 5000);
        }
      },
      (data) => {
        this.allApplicantsDoneLoading = true;

        if (loading) {
          this.remain_loading_count--;
        }

        this.pendingApplicants = [];
        this.allApplicants = [];
        this.hiredApplicants = [];
        this.busy = false;
        this.unSetLoader();
      }
    );
  }

  formatQuitReason(quitReason) {
    let result;

    if (quitReason) {
      result = QUIT_REASONS.find((o) => o.name === quitReason);
      if (result) {
        result = result.description;
      }
    } else {
      //result = "Work was a bad fit.";
    }

    return result;
  }

  processRejectionReason(rejectionReason) {
    let result;

    if (rejectionReason.length > 0) {
      rejectionReason.forEach(function (reason, index) {
        //console.log("each reason");
        //console.dir(reason);
        if (index === 0) {
          if (reason[0] === "MANAGER_REJECTED") {
            result = "This user was manually removed from the job after they were hired by an account manager.";
          } else if (reason[0] === "AUTO_REJECTED") {
            result =
              "This user was automatically removed after they were hired for failure to comply with our Confirmation, Checkin and Checkout requirements.";
          } else if (reason[0] === "AUTO_REJECTED_PRE_HIRE") {
            result =
              "This user was automatically removed before they were hired for failure to comply with our Confirmation, Checkin and Checkout requirements.";
          } else if (reason[0] === "MANAGER_REJECTED_PRE_HIRE") {
            result = "This user was manually removed from the job before they were hired by an account manager.";
          } else {
            result = "The reason is unknown. Please contact support.";
          }
        }
      });
    } else {
      result = "The reason is unknown. Please contact support.";
    }

    return result;
  }

  setTabFilter(status) {
    console.log("setTabFilter");
    console.dir(status);

    if (this.statusNumbers[status] === 0) return;

    this.tabFilter = status;
    this.checkOrUncheckAll(false);

    if (this.tabFilter === 1) {
      this.reSortHired(true);
      this.$timeout(() => {
        this.initializeMap();
      });
    }

    if (this.tabFilter === 2) {
      this.enableToolTips();
    }

    if (this.tabFilter === 3) {
      this.enableToolTips();
    }

    if (this.tabFilter === 4) {
      this.enableToolTips();
    }

    this.activateDropdownCSS();
  }

  activateDropdownCSS() {
    $(".checkbox-menu").on("change", "input[type='checkbox']", function () {
      $(this).closest("li").toggleClass("active", this.checked);
    });

    $(document).on("click", ".allow-focus", function (e) {
      e.stopPropagation();
    });
  }

  setCounts(applications) {
    this.statusNumbers = {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
    };

    if (!applications || !applications.length) return;

    applications.forEach((application) => {
      let status = application.applicationStatusRoster.id;
      this.statusNumbers[status] = this.statusNumbers[status] + 1;
    });

    if (this.statusNumbers[this.tabFilter] === 0) {
      if (this.statusNumbers[1] !== 0) {
        this.tabFilter = 1;
        this.reSortHired(true);
        this.$timeout(() => {
          this.initializeMap();
        });
        this.$timeout(() => {
          this.activateDropdownCSS();
        });
      } else if (this.statusNumbers[3] !== 0) {
        this.tabFilter = 3;
      } else if (this.statusNumbers[2] !== 0) {
        this.tabFilter = 2;
      } else if (this.statusNumbers[4] !== 0) {
        this.tabFilter = 4;
      } else if (this.statusNumbers[5] !== 0) {
        this.tabFilter = 5;
      } else if (this.statusNumbers[7] !== 0) {
        this.tabFilter = 7;
      } else {
        this.tabFilter = 3;
      }
    }
  }

  filterHired(applications) {
    return _.filter(applications, (application) => {
      //return application.applicationStatus === 1;
      return application.applicationStatusRoster.id === 1;
    });
  }

  filterRemoved(applications) {
    return _.filter(applications, (application) => {
      //return application.applicationStatus === 1;
      return application.applicationStatusRoster.id === 4;
    });
  }

  reSortHired(force, map) {
    if (force && !map) {
      this.sortOrder = "asc";
      this.sortField = "confirmation";
    }

    if (force && map) {
      this.sortOrder = "asc";
      this.sortField = "status-number";
    }

    this.hiredApplicants = this.sortHired(this.hiredApplicants);

    this.enableToolTips();
  }

  bulkChangeShiftNoShowValue(value) {
    let applicants = [];

    this.hiredApplicants.forEach((applicant) => {
      if (applicant.isChecked) {
        applicants.push(applicant);
      }
    });

    if (value) {
      this.$tracking.reportRosterPageSubmit("bulk mark as no show");
    } else {
      this.$tracking.reportRosterPageSubmit("bulk unmark as no show");
    }

    if (!applicants.length) {
      this.checkOrUncheckAll(false);
      return;
    }

    async.mapSeries(
      applicants,
      (applicant, cb) => {
        const shift = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId];
        this.changeShiftNoShowValue(shift, value, cb);
      },
      (err) => {
        this.checkOrUncheckAll(false, true);
      }
    );
  }

  changeShiftNoShowValue(shift, value, cb) {
    //console.log("shift no", shift);

    const {shiftId} = shift;

    this.$timeout(() => {
      this.setLoader();
    });

    if (value) {
      this.$tracking.reportRosterPageSubmit("mark as no show");
    } else {
      this.$tracking.reportRosterPageSubmit("unmark as no show");
    }

    this.$events.markUserAsNowShowForShiftNew(shiftId, value).then(
      (response) => {
        console.log("response");
        console.dir(response);

        this.$timeout(() => {
          this.unSetLoader();
          this.checkOrUncheckAll(false);
        });

        this.updateNoShowValue(shift.shiftPosition, shift.applicantId, value, value ? 0 : null);

        if (cb) cb(null);
      },
      (error) => {
        console.log("in error");
        console.dir(error);

        this.$timeout(() => {
          this.unSetLoader();
          this.checkOrUncheckAll(false);
        });

        if (cb) cb(null);
      }
    );
  }

  sortHired(applications) {

    if (applications.length === 0) {
      this.unSetLoader();
    }

    if (!applications || !applications.length) return applications;

    if (this.sortField === "confirmation" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
      const newHired = applications.sort((a, b) => {
        const responseA = this.shiftConfirmationData[this.singleShiftViewShiftPosition][a.applicantId]; //.confirmationResponse
        const responseB = this.shiftConfirmationData[this.singleShiftViewShiftPosition][b.applicantId]; //.confirmationResponse

        const nameA = (responseA && responseA.confirmationResponseExists ? (responseA.confirmationResponse ? 0 : 2) : 1) + a.applicantLastName;
        const nameB = (responseB && responseB.confirmationResponseExists ? (responseB.confirmationResponse ? 0 : 2) : 1) + b.applicantLastName;

        let response = 0;
        if (nameA < nameB) response = -1;
        if (nameA > nameB) response = 1;

        if (this.sortOrder === "desc") response = response * -1;

        return response;
      });

      return newHired;
    } else if (this.sortField === "check-in" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
      const newHired = applications.sort((a, b) => {
        const responseA = this.shiftConfirmationData[this.singleShiftViewShiftPosition][a.applicantId]; //.confirmationResponse
        const responseB = this.shiftConfirmationData[this.singleShiftViewShiftPosition][b.applicantId]; //.confirmationResponse

        const checkInTimeA = (responseA.checkInTime ? moment(responseA.checkInTime) : moment("10/10/9999")).valueOf();
        const checkInTimeB = (responseB.checkInTime ? moment(responseB.checkInTime) : moment("10/10/9999")).valueOf();

        let response = 0;
        if (checkInTimeA < checkInTimeB) response = -1;
        if (checkInTimeA > checkInTimeB) response = 1;

        if (this.sortOrder === "desc") response = response * -1;

        return response;
      });

      return newHired;
    } else if (this.sortField === "check-out" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
      const newHired = applications.sort((a, b) => {
        const responseA = this.shiftConfirmationData[this.singleShiftViewShiftPosition][a.applicantId];
        const responseB = this.shiftConfirmationData[this.singleShiftViewShiftPosition][b.applicantId];

        const checkOutTimeA = (responseA.checkOutTime ? moment(responseA.checkOutTime) : moment("10/10/9999")).valueOf();
        const checkOutTimeB = (responseB.checkOutTime ? moment(responseB.checkOutTime) : moment("10/10/9999")).valueOf();

        let response = 0;
        if (checkOutTimeA < checkOutTimeB) response = -1;
        if (checkOutTimeA > checkOutTimeB) response = 1;

        if (this.sortOrder === "desc") response = response * -1;

        return response;
      });

      return newHired;
    } else if (this.sortField === "status-number" && this.shiftConfirmationData && this.shiftConfirmationData[this.singleShiftViewShiftPosition]) {
      const newHired = applications.sort((a, b) => {
        let responseA = this.shiftConfirmationData[this.singleShiftViewShiftPosition][a.applicantId];
        let responseB = this.shiftConfirmationData[this.singleShiftViewShiftPosition][b.applicantId];

        responseA = responseA ? responseA.statusNumber : 999;
        responseB = responseB ? responseB.statusNumber : 999;

        let response = 0;
        if (responseA < responseB) response = -1;
        if (responseA > responseB) response = 1;

        if (this.sortOrder === "desc") response = response * -1;

        return response;
      });

      return newHired;
    } else {
      return applications;
    }
  }

  filterByStatus(applications, status) {
    return _.filter(applications, (application) => {
      return application.applicationStatus === status;
    });
  }

  closeActionMenu(index) {
    let i = index + 1;

    this.$timeout(() => {
      $("table.jobble-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").hide();
      $("table.jobble-table tbody tr:nth-child(" + i + ") td").removeClass("row-focus");
    }, 150);
  }

  paginate(pageNumber, list) {
    this.currentPageNumber = pageNumber;
    var _this = this;
    if (list === "pending") {
      _this.pendingApplicants = [];
      var offset = pageNumber * 12 - 12;
      _this.remain_loading_count++;
      _this.$events.getPendingApplications(_this.event.subEvents[0].id, 12, offset).then(
        function (pendingApplications) {
          pendingApplications.data.forEach(function (pendingApplication) {
            if (_this.approvedApplicants.length > 0) {
              _this.approvedApplicants.forEach(function (approvedApplicant) {
                if (approvedApplicant.applicant.id === pendingApplication.applicant.id) {
                  pendingApplication.isHireSelected = true;
                }
              });
            }
            pendingApplication.hasBeenSelected = false;
            pendingApplication.renderPhoto = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
            pendingApplication.renderPhotoThumb = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
            _this.setJobblerRatingPending(pendingApplication);
          });
          for (var i = _this.pendingApplicants.length - 1; i >= 0; i--) {
            if (_this.pendingApplicants[i].isHireSelected) {
              _this.pendingApplicants[i].isHireSelectedLast = true;
              break;
            }
          }
          _this.remain_loading_count--;
        },
        function (data) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    } else {
      var offset = pageNumber * 10 - 10;
      _this.acceptedApplicants = [];
      _this.remain_loading_count++;
      _this.$events.getAcceptedApplications(_this.event.subEvents[0].id, 10, offset).then(
        function (acceptedApplications) {
          if (acceptedApplications.data.length !== 0) {
            acceptedApplications.data.forEach(function (acceptedApplication) {
              acceptedApplication.renderPhoto = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
              acceptedApplication.renderPhotoBig = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
              acceptedApplication.renderPhotoThumb = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 0) {
                acceptedApplication.applicant.displayRating = 1;
              }
              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 1) {
                acceptedApplication.applicant.displayRating = 1;
              }
              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 2) {
                acceptedApplication.applicant.displayRating = 2;
              }
              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 3) {
                acceptedApplication.applicant.displayRating = 3;
              }
              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 4) {
                acceptedApplication.applicant.displayRating = 4;
              }
              if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 5) {
                //console.log('THIS SHOULD SHOW');
                acceptedApplication.applicant.displayRating = 5;
              }
              _this.noOneAcceptedYet = false;
              _this.acceptedApplicants.push(acceptedApplication);
              _this.combineApplicants();
            });
          }
          _this.remain_loading_count--;
        },
        function (data) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  combineApplicants() {
    this.allApplicants = _.concat(this.pendingApplicants, this.acceptedApplicants);
  }

  mapProfileForReject(data) {
    var _this = this;

    console.log("mapping profile");
    console.dir(data);

    let a = {};

    a.applicant = {};
    a.jobble = {};
    a.applicant.homeContactInfo = {};
    a.applicant.username = data.email;
    a.applicant.homeContactInfo.phoneMobile = data.number;
    a.applicant.id = data.jobblerId;
    a.applicant.displayRating = data.average;
    a.applicant.numberOfCompletedJobbles = data.completed;
    a.applicant.firstName = data.firstName;
    a.applicant.isVerified = true;
    a.applicant.lastName = data.lastName;
    a.jobble.id = data.jobbleId;

    console.log("mapProfileForReject");
    console.dir(a);

    return a;
  }

  confirmRemoveJobbler(type, data) {
    var _this = this;
    _this.remain_loading_count++;

    console.log("confirmRemoveJobbler");
    console.dir(type);
    console.dir(data);
    console.dir(_this.applicantStatus);

    if (_this.applicantStatus === 2 || data) {
      console.log("confirmRemoveJobbler");
      console.dir(type);
      console.dir(data);
      if (data) {
        _this.applicationForReject = _this.mapProfileForReject(data);
        console.log("_this.applicationForReject");
        console.dir(_this.applicationForReject);
      }
      var rejectJobblerReq = {
        method: "POST",
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.applicationForReject.applicant.id +
          "/jobbles/" +
          _this.applicationForReject.jobble.id +
          "/reject?format=json&conf=web",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };
      _this.$http(rejectJobblerReq).then(function (response) {
        _this.remain_loading_count--;
        if (response.data.status === "error") {
          _this.applicationForReject = null;
          alert("Error: " + response.data.message);
        } else {
          for (var i = _this.pendingApplicants.length - 1; i >= 0; i--) {
            if (_this.pendingApplicants[i].applicant.id === _this.applicationForReject.applicant.id) {
              _this.setRejectedApplicantToDirective(_this.applicationForReject);
              _this.pendingApplicants.splice(i, 1);
              _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - 1;
              _this.applicationForReject = null;
              break;
            }
          }
        }
        if (!data) {
          _this.$timeout(function () {
            jQuery("#modal-fire-jobbler-new").modal("toggle");
          }, 100);
        } else {
          _this.$timeout(function () {
            jQuery("#modal-view-jobble").modal("toggle");
          }, 100);
        }
      });
    } else {
      console.log("we are in the else");
      console.dir(_this.applicationForReject);

      if (_this.applicationForReject) {
        _this.selectedApplicant = _this.applicationForReject;
      }

      var rejectJobblerReq = {
        method: "POST",
        url:
          _this.$env.getAPIEndPoint() +
          "jbl/v1/users/" +
          _this.selectedApplicant.applicant.id +
          "/jobbles/" +
          _this.selectedApplicant.jobble.id +
          "/reject?format=json&conf=web",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _this.currentUser.access_token,
        },
        data: {},
      };

      _this.$http(rejectJobblerReq).then(function (response) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#modal-fire-jobbler-new").modal("toggle");
        });

        if (response.data.status === "error") {
          _this.applicationForReject = null;
          _this.selectedApplicant = null;
          _this.$timeout(function () {
            alert("Error : " + response.data.message);
          }, 300);
        } else {
          for (var i = _this.acceptedApplicants.length - 1; i >= 0; i--) {
            if (_this.acceptedApplicants[i].applicant.id === _this.selectedApplicant.applicant.id) {
              _this.setRejectedApplicantToDirective(_this.selectedApplicant);
              _this.acceptedApplicants.splice(i, 1);
              _this.selectedApplicant = null;
              _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications - 1;
              _this.event.numberOfOpenings = _this.event.numberOfOpenings + 1;
              break;
            }
          }
        }
      });
    }
  }

  rejectApplicant(pendingApplicant) {
    var _this = this;
    _this.applicationForReject = pendingApplicant;
    _this.$timeout(function () {
      jQuery("#modal-fire-link-clicker").trigger("click");
    });
  }

  removeHireApplicant(pendingApplicant) {
    console.log("removeHireApplicant");
    console.dir(pendingApplicant);

    if (pendingApplicant.isChecked) {
      console.log("does he pass this...");
      pendingApplicant.isHireSelected = false;
      pendingApplicant.isHiredClass = "";
      this.showAppWarning = false;
      pendingApplicant.isChecked = false;
      /*
            if (pendingApplicant.hasPaymentProblem) {
                pendingApplicant.showPayInfoWarning = true;
            }
             */
      var index = -1;

      for (var i = this.allApplicants.length - 1; i >= 0; i--) {
        if (this.allApplicants[i].id == pendingApplicant.id) {
          index = i;
          break;
        }
      }
      if (index != -1) {
        this.allApplicants.splice(index, 1);
      }
    }
  }

  acceptHireApplicant(pendingApplicant) {
    if (!pendingApplicant.isHireSelected) {
      var totalApprovedCount = this.approvedApplicants.length;
      if (totalApprovedCount >= this.event.numberOfOpenings) {
        return;
      }
      pendingApplicant.isHireSelected = true;
      pendingApplicant.isHiredClass = "green-accept";
      var selectedHireApplicant = 0;
      this.approvedApplicants.push(pendingApplicant);
    }
  }

  goToMessages(applicantId) {
  }

  toggleConfirmScreen(pendingApplicant) {
    var _this = this;
    _this.approvedApplicants = [];
    _this.approvedApplicants.push(pendingApplicant);
  }

  hireAll() {
    var _this = this;

    _this.pendingApplicants.forEach(function (pendingApplicant) {
      if (pendingApplicant.showPayInfoWarning) {
        pendingApplicant.showPayInfoWarning = false;
      }
      pendingApplicant.isHiredClass = "green-accept";
      pendingApplicant.isHireSelected = !pendingApplicant.isHireSelected;
      _this.approvedApplicants.push(pendingApplicant);
    });
  }

  toggleHireApplicant(pendingApplicant) {
    var _this = this;

    if (_this.currentUser.company.undeletedPaymentInfos.length === 0 && _this.currentUser.company.payByInvoice !== true) {
      alert(
        "Please go to your account settings and enter a payment method. " + "You cannot hire until you have entered some form of payment method."
      );
      return;
    }

    if (this.approvedApplicants.length === this.event.numberOfOpenings) {
      $("#reached-openings-limit").modal();
      return;
    }

    if (pendingApplicant.showPayInfoWarning) {
      pendingApplicant.hasPaymentProblem = true;
    }

    var selectedHireApplicant = 0;

    pendingApplicant.isHiredClass = "green-accept";
    pendingApplicant.isHireSelected = !pendingApplicant.isHireSelected;

    var index = -1;

    if (pendingApplicant.isHireSelected) {
      console.log("we get pushed into here");
      this.approvedApplicants.push(pendingApplicant);
    } else {
      for (var i = this.approvedApplicants.length - 1; i >= 0; i--) {
        if (this.approvedApplicants[i].id == pendingApplicant.id) {
          this.approvedApplicants[i].isHiredClass = "";
          index = i;
          break;
        }
      }
      if (index != -1) this.approvedApplicants.splice(index, 1);
    }
    this.pendingApplicants.forEach(function (applicant) {
      applicant.isHireSelectedLast = false;
      if (applicant.isHireSelected) {
        selectedHireApplicant++;
      }
    });
    this.selectedHireApplicant = selectedHireApplicant;
  }

  setModalViewJobble() {
    this.applicant_name = "Scarlett Jr.";
  }

  formatPhoneNumber(phoneNumberString) {
    console.log("formatPhoneNumber");
    console.dir(phoneNumberString);

    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");

    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "+1 (" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  }

  displayDetails(application, type, action, index, isLink, wantsToMessage) {
    var _this = this;

    console.log("displayDetails");
    console.dir(application);

    application.applicantPhoneNumber = this.formatPhoneNumber(application.applicantPhoneNumber);

    var applicationIndexInArray = index;
    var typeOfApplication = type;
    var typeOfAction = action;
    var heightOfModal = this.$window.innerHeight - 73;

    _this.setLoader();

    _this.$rootScope.$emit("GetJobblerDataCached", {application});

    _this.$security.getApplicationInfoTrimmedv2(application).then(function (response) {
      if (type === "default" || type === "hired") {
        if (!application.direction && !isLink) {
          _this.$timeout(function () {
            //jQuery("#modal-view-jobble-new").modal();
            $("#modal-view-jobble").modal();
          });
        } else {
          _this.$timeout(function () {
            $("#modal-view-jobble").modal();
          });
        }
      }

      var jobblerData = _this.$security.getJobblerData(
        response.data,
        type,
        action,
        application.renderPhotoBig,
        applicationIndexInArray,
        _this.pendingApplicants.length,
        _this.acceptedApplicants.length,
        application
      );

      jobblerData.index = applicationIndexInArray;
      jobblerData.type = typeOfApplication;
      jobblerData.action = typeOfAction;

      _this.$timeout(function () {
        _this.$rootScope.$emit("GetJobblerDataFromService", {
          event: _this.event,
          jobblerData: jobblerData,
          messaging: wantsToMessage,
          application: application,
          type: type,
          heightOfModal: heightOfModal,
        });

        $("#modal-view-jobble").focus();
      });

      _this.unSetLoader();
    });
  }

  sendPublishForView(applicant) {
    var _this = this;

    var msg =
      "Your application has been reviewed by " + _this.currentUser.firstName + " " + _this.currentUser.lastName + " for the job: " + _this.event.name;
    _this.$messagingv2.publishMessagev1(msg, null, null, applicant, null);
  }

  selectApplicantReject(selectedApplicant, status) {
    this.applicationForReject = selectedApplicant;
    this.applicantStatus = status;

    this.$timeout(function () {
      jQuery("#modal-fire-jobbler-new").modal();
    });
  }

  selectApplicant(selectedApplicant) {
    this.selectedApplicant = selectedApplicant;
    this.hireJobblerResult.status = "";
    this.hireJobblerResult.message = "";
    this.removeJobblerResult.status = "";
    this.removeJobblerResult.message = "";
  }

  cancelRemoveJobbler() {
    _this.$timeout(function () {
      jQuery("#modal-remove-jobbler .modal-header button.close").trigger("click");
    });
  }

  cancelHireJobblers() {
    _this.$timeout(function () {
      jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
    });
  }

  cancelFireJobblers() {
    _this.$timeout(function () {
      jQuery("#modal-fire-jobbler .modal-header button.close").trigger("click");
    });
  }

  triggeredHireJobbler() {
    var _this = this;

    console.log("triggeredHireJobbler");
  }

  checkForExistingChannelForThisEvent() {
    let res = false;
    try {
      if (this.$rootScope.channels) {
        let channels_and_event = this.$rootScope.channels.find((o) => o.eventId === this.event.id);

        if (channels_and_event) {
          let default_channel_inddex = channels_and_event.channelArrayHolder.findIndex((o) => o.isDefault === true);

          if (default_channel_inddex > -1) {
            res = true;
          }
        }
      }
    } catch (err) {
      console.log("error looking for defualt chat");
      console.dir(err);
    }

    return res;
  }

  hireJobblers(arg) {
    var _this = this;

    var jobblesAndApplicants = [];
    var trackingData = [];
    var putApplicationId = null;
    var isPut = false;

    var first_chat_or_default_chat = _this.checkForExistingChannelForThisEvent();

    try {
      if (!_this.event.isSourcingPost) {
        if (!first_chat_or_default_chat) {
          _this.$timeout(function () {
            _this.$rootScope.$emit("JobblerIsBeingHired", {});
          });
        }
        for (var i = this.pendingApplicants.length - 1; i >= 0; i--) {
          if (this.pendingApplicants[i].isHireSelected) {
            trackingData.push(this.pendingApplicants[i]);
            if (!_this.event.isSourcingPost) {
              var jobbleObjForApplication = {};
              jobbleObjForApplication.applicant = this.pendingApplicants[i].applicant.id;
              jobbleObjForApplication.jobble = this.pendingApplicants[i].jobble.id;
              jobbleObjForApplication.index = i;
              jobbleObjForApplication.eventId = _this.event.id;
              if (_this.event.orderNumber) {
                jobbleObjForApplication.is_order = true;
              } else {
                jobbleObjForApplication.is_order = false;
              }
              jobblesAndApplicants.push(jobbleObjForApplication);
            } else {
              isPut = true;
              putApplicationId = this.pendingApplicants[i].id;
            }
          }
        }
      } else {
        isPut = true;
        for (var i = this.approvedApplicants.length - 1; i >= 0; i--) {
          putApplicationId = this.approvedApplicants[i].id;
        }
      }
    } finally {
      var hireJobblersData = {};
      if (!_this.event.isSourcingPost) {
        hireJobblersData = {
          method: "POST",
          url: _this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-accept?format=json&conf=web",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
          data: {
            jobblesAndApplicants: jobblesAndApplicants,
            verified: true,
          },
        };
      } else {
        hireJobblersData = {
          method: "PUT",
          url:
            _this.$env.getAPIEndPoint() +
            "jbl/v1/applications/" +
            putApplicationId +
            "?format=json&fields=id,applicationStatus.id,applicationStatus.name,applicant.firstName,applicant.lastName,applicant.averageRatingReceived,applicant.filePROFILE_IMAGE1IMG_75x75,jobble.id,applicant.id,applicant.homeContactInfo.city,applicant.homeContactInfo.state,applicant.username,applicant.numberOfCompletedJobbles",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + _this.currentUser.access_token,
          },
          data: {applicationStatus: {id: 1, name: "ACCEPTED"}},
        };
      }

      _this.remain_loading_count++;
      _this.$http(hireJobblersData).then(
        function (response) {
          console.log("response");
          console.dir(response);

          _this.remain_loading_count--;

          if (response) {
            if (isPut) {
              _this.handlePut(putApplicationId, response, trackingData, arg);
              return;
            }
            if (response.data[0].status === "error") {
              _this.hireJobblerResult.status = "error";
              _this.hireJobblerResult.message = response.data[0].message;
              if (arg && arg.action === "close") {
                alert("Error with this user looking to handle this");
              }
              return;
            }

            if (first_chat_or_default_chat === false) {
              let data = {};
              data.event = _this.event;
              data.response = response;
              _this.$timeout(function () {
                _this.$rootScope.$emit("AddChannelToList", data);
              });
            }
            _this.pendingApplicants.forEach(function (applicant) {
              if (applicant.isHireSelected) {
                _this.acceptedApplicants.push(applicant);
              }
            });
            jobblesAndApplicants.forEach(function (applicant) {
              _this.pendingApplicants.splice(applicant.index, 1);
            });
            _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications + jobblesAndApplicants.length;
            _this.event.numberOfOpenings = _this.event.numberOfOpenings - jobblesAndApplicants.length;
            _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - jobblesAndApplicants.length;
            _this.$tracking.reportApplicationAcceptance(_this.event, _this.currentUser, trackingData);
            if (arg && arg.action === "close") {
              _this.$timeout(function () {
                jQuery("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
              });
            } else {
              _this.$timeout(function () {
                jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
              });
            }
            _this.fancyLoad("#review-accepted-applicants tbody tr", _this.acceptedApplicants.length);
            _this.resetApprovedApplicants();
          } else {
            if (arg && arg.action === "close") {
              _this.$timeout(function () {
                jQuery("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
              });
            } else {
              _this.$timeout(function () {
                jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
              });
            }

            _this.$timeout(function () {
              alert("The server has timed out. There was an issue with the page. Please notify support.");
            }, 1000);
          }
        },
        function (response) {
          _this.remain_loading_count--;
          _this.$timeout(function () {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
        }
      );
    }
  }

  bulkHireApplicants() {
    let applicants = [];

    this.allApplicants.forEach((applicant) => {
      if (applicant.isChecked) {
        applicants.push(applicant);
      }
    });

    this.$tracking.reportRosterPageSubmit("bulk hire");

    if (!applicants.length) {
      this.checkOrUncheckAll(false);
      return;
    }

    if (this.isThereRoomForHire === false) {
      alert(
        "Our system is reporting that there are no more openings to fill in this job. Please contact an admin to help create more openings so that more users can be hired to this job."
      );
      return;
    }

    this.hireJobblersNew(applicants);
  }

  bulkRejectApplicants() {
    let applicants = [];
    this.allApplicants.forEach((applicant) => {
      if (applicant.isChecked) {
        applicants.push(applicant);
      }
    });

    this.$tracking.reportRosterPageSubmit("bulk reject");

    if (!applicants.length) {
      this.checkOrUncheckAll(false);
      return;
    }

    this.rejectJobblersNew(applicants);
  }

  getApplicantUniqueShiftId(shiftPosition, applicantId) {
    if (!this.shiftConfirmationData || !this.shiftConfirmationData[shiftPosition]) {
      console.error("Shift confirmation data has not loaded yet", applicantId);
      return null;
    }

    if (!this.shiftConfirmationData[shiftPosition][applicantId]) {
      console.error("Shift confirmation data has not loaded yet for this applicant", applicantId);
      return null;
    }

    return this.shiftConfirmationData[shiftPosition][applicantId].shiftId;
  }

  bulkCheckInOrOutJobblers(checkOut) {
    let applicants = [];

    this.allApplicants.forEach((applicant) => {
      if (applicant.isChecked) {
        applicants.push(applicant);
      }
    });

    this.$tracking.reportRosterPageSubmit(`bulk check ${checkOut ? "out" : "in"}`);

    this.checkInOrOutJobblers(applicants, checkOut);
  }

  checkInOrOutJobblers(applicants, checkOut, formatted_date, dateforDB, shift) {
    this.$tracking.reportRosterPageSubmit(`check ${checkOut ? "out" : "in"}`);

    shift = shift || this.singleShiftViewShift;

    if (!shift) return console.error("No single shift is selected");

    let payLoad = {jobblesAndApplicants: []};

    const coordsForCheckIn = {
      lat: shift.contactInfo.lat,
      lng: shift.contactInfo.lng,
    };

    applicants.forEach((applicant) => {
      let jobbleAndApplicant = {};

      const shiftPosition = shift.shiftPosition;

      const shiftId = this.getApplicantUniqueShiftId(shiftPosition, applicant.applicantId);

      jobbleAndApplicant.jobble = applicant.jobbleId;
      jobbleAndApplicant.applicant = applicant.applicantId;
      jobbleAndApplicant.coord = coordsForCheckIn;
      jobbleAndApplicant.shift = shiftId;
      jobbleAndApplicant.isManager = true;

      if (dateforDB) {
        jobbleAndApplicant.date = dateforDB;
      }

      let exists = false;

      console.log(applicant.applicantId, this.shiftConfirmationData[shiftPosition], this.shiftConfirmationData[shiftPosition][applicant.applicantId]);

      if (
        this.shiftConfirmationData &&
        this.shiftConfirmationData[shiftPosition] &&
        this.shiftConfirmationData[shiftPosition][applicant.applicantId]
      ) {
        if (checkOut) {
          exists = this.shiftConfirmationData[shiftPosition][applicant.applicantId].checkOutTime;
        } else {
          exists = this.shiftConfirmationData[shiftPosition][applicant.applicantId].checkInTime;
        }
      }

      console.log(applicant.applicantId, exists, dateforDB);

      if (!exists || dateforDB) {
        payLoad.jobblesAndApplicants.push(jobbleAndApplicant);
      }
    });

    if (payLoad.jobblesAndApplicants.length) {
      this.remain_loading_count++;

      this.$events.checkJobblerInOrOut(payLoad, checkOut ? 2 : 1).then(
        (response) => {
          this.remain_loading_count--;

          console.log("check in/out response", response.data);

          let now = dateforDB ? moment(dateforDB) : moment();
          const time = now.format("MMM DD, h:mm a").toUpperCase();

          payLoad.jobblesAndApplicants.forEach((applicant) => {
            const applicantId = applicant.applicant;
            const shiftPosition = shift.shiftPosition;

            if (checkOut) {
              this.updateCheckInOutData(shiftPosition, applicantId, null, time, now);
            } else {
              this.updateCheckInOutData(shiftPosition, applicantId, time, null, now);
            }
          });

          this.reloadApplicants();
        },
        (data) => {
          this.remain_loading_count--;

          console.error(data);

          this.reloadApplicants();
        }
      );
    } else {
      this.checkOrUncheckAll(false);
    }
  }

  rejectJobblersNew(applicants) {
    let applicantsData = [];
    let paymentContingencies = false;
    let paymentContingenciesMap = {};

    applicants.forEach((applicant) => {
      applicantsData.push({
        applicantId: applicant.applicantId,
        jobbleId: applicant.jobbleId,
      });
    });

    applicants.forEach((applicant) => {
      Object.keys(this.shiftConfirmationData || []).forEach((singleShiftViewShiftPosition) => {
        let confirmationData = this.shiftConfirmationData[singleShiftViewShiftPosition][applicant.applicantId];
        let shift = this.convertedShiftsMap[singleShiftViewShiftPosition];

        if (!confirmationData) return;

        if (shift.shiftEnded && confirmationData.statusNumber !== 4 && confirmationData.statusNumber !== 5) {
          paymentContingencies = true;
          paymentContingenciesMap[singleShiftViewShiftPosition] = paymentContingenciesMap[singleShiftViewShiftPosition] || [];
          paymentContingenciesMap[singleShiftViewShiftPosition].push(applicant);
        }
      });
    });

    console.log("paymentContingencies", paymentContingencies);
    console.log("paymentContingenciesMap", paymentContingenciesMap);

    this.paymentContingenciesMap = paymentContingenciesMap;
    this.paymentContingenciesShiftPositions = Object.keys(paymentContingenciesMap);

    this.rejectionApplicationData = applicantsData;
    this.rejectionApplicants = applicants;

    this.calculateTotalPaymentOnRejectionEdit();

    if (this.tabFilter === 1) {
      if (paymentContingencies) {
        this.$timeout(() => {
          jQuery("#modal-rejection-shift-payment").modal({
            backdrop: true,
          });
        }, 100);
      } else {
        this.$timeout(() => {
          jQuery("#modal-rejection-confirm").modal({
            backdrop: true,
          });
        }, 100);
      }
    } else {
      this.runRejection(applicantsData);
    }
  }

  submitModalRejection() {
    this.$timeout(() => {
      jQuery("#modal-rejection-confirm .modal-header button.close").trigger("click");
      this.runRejection(this.rejectionApplicationData);
    });
  }

  runRejection(applicantsData) {
    console.log("SENDING DATE", applicantsData);

    this.$tracking.reportRosterPageSubmit("reject");

    const rejectJobblersData = {
      method: "POST",
      url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-reject?format=json&conf=web",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.currentUser.access_token,
      },
      data: {
        applicants: applicantsData,
      },
    };

    this.remain_loading_count++;

    this.$http(rejectJobblersData).then(
      (response) => {
        this.remain_loading_count--;
        //this.unSetLoader();

        console.log("Reject response", response.data);

        this.$timeout(() => {
          this.reloadApplicants();
        }, 0);

        if (response.data && response.data.applicants) {
          let notificationApplicants = response.data.applicants.map((applicant) => {
            if (applicant.status === "OK") {
              const {id, jobbleId, rejectingPreviouslyAcceptedUser} = applicant;

              return {
                applicantId: id,
                jobbleId,
                rejectingPreviouslyAcceptedUser,
              };
            } else {
              return null;
            }
          });

          notificationApplicants = _.without(notificationApplicants, null);

          console.log("notificationApplicants", notificationApplicants);

          if (notificationApplicants.length) {
            const rejectJobblersNotificationsData = {
              method: "POST",
              url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-reject-notifications?format=json&conf=web",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + this.currentUser.access_token,
              },
              data: {
                applicants: notificationApplicants,
              },
            };

            this.notifyJobblersOfRejection(rejectJobblersNotificationsData);
          }

          if (response.data.status === "error") {
            this.handleRejectionError(response.data);
          }
        }
      },
      (response) => {
        this.remain_loading_count--;
        console.error(response);
        this.reloadApplicants();
        //this.unSetLoader();
      }
    );
  }

  handleRejectionError(data) {
    console.log("handleRejectionError");
    console.dir(data);
    console.dir(this.remain_loading_count);
    let emailOfErrors = [];
    let errorMessage = "There was a back end error removing ";

    if (data) {
      if (data.applicants) {
        data.applicants.forEach((applicant) => {
          if (applicant.status === "error") {
            emailOfErrors.push(applicant.message.checkResult.applicant.email);
            let email = applicant.message.checkResult.applicant.email;
            errorMessage = errorMessage + email + " ";
          }
        });
      }
    }

    errorMessage = errorMessage + " from the job. Please contact support.";

    console.log("emailOfErrors");
    console.dir(emailOfErrors);

    alert(errorMessage);

    this.$timeout(() => {
      this.unSetLoader();
    }, 1000);
  }

  notifyJobblersOfRejection(rejectJobblersNotificationsData) {
    this.$timeout(() => {
      this.$http(rejectJobblersNotificationsData).then(
        (response) => {
          console.log("Reject notifications response", response.data);
        },
        (response) => {
          console.error(response);
        }
      );
    }, 2000);
  }

  hireJobblersNew(applicants) {
    let jobblesAndApplicants = [];
    let trackingData = [];

    this.$tracking.reportRosterPageSubmit("hire");

    console.log("this.allApplicants");
    console.dir(this.allApplicants);

    try {
      applicants.forEach((applicant, i) => {
        console.log(applicant);
        console.dir(this.approvedApplicants);

        trackingData.push(applicant);

        let jobbleObjForApplication = {};

        jobbleObjForApplication.applicant = applicant.applicantId;
        jobbleObjForApplication.jobble = applicant.jobbleId;
        jobbleObjForApplication.index = i;
        jobbleObjForApplication.eventId = this.event.id;
        jobbleObjForApplication.is_order = !!this.event.orderNumber;

        jobblesAndApplicants.push(jobbleObjForApplication);
      });
    } finally {
      console.log("jobblesAndApplicants", jobblesAndApplicants);

      const hireJobblersData = {
        method: "POST",
        url: this.$env.getAPIEndPoint() + "jbl/v1/jobbles/bulk-accept?format=json&conf=web",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.currentUser.access_token,
        },
        data: {
          jobblesAndApplicants: jobblesAndApplicants,
          verified: true,
        },
      };

      this.remain_loading_count++;

      this.$http(hireJobblersData).then(
        (response) => {
          console.log("do we even have a response");
          console.dir(response);

          if (response.data.length === 0) {
            this.remain_loading_count--;
            this.$timeout(() => {
              alert("There was an issue with one or more of the users being hired. Please contact support");
            }, 100);
            return;
          }

          if (response.data.status === "error") {
            console.error("bulk hire error", response.data);

            const {message} = response.data.message;

            if (message && message.toLowerCase() === "could not find a jobble to accept") {
              alert("There aren't enough openings available to hire this applicant. Please add more openings and try hiring again.");
            } else if (
              message &&
              (message.toLowerCase().indexOf("already booked for this time frame") !== -1 ||
                message.toLowerCase().indexOf("already accepted for a position") !== -1)
            ) {
              alert("This jobbler has already been hired for another job that is at the same as this shift");
            } else if (message && message.toLowerCase() === "no application for this jobble by the user was found") {
              alert("This jobbler could not be hired for this job because their application has been cancelled");
            } else {
              alert("An unknown server error occurred:\n\nAPI Error: " + message);
            }

            this.remain_loading_count--;

            this.hireJobblerResult.status = "error";
            this.hireJobblerResult.message = response.data.message;
            this.reloadApplicants();
            this.ui.allChecked = false;

            return;
          }

          this.$timeout(() => {
            this.remain_loading_count--;
            this.event.numberOfApprovedApplications = this.event.numberOfApprovedApplications + jobblesAndApplicants.length;
            this.event.numberOfOpenings = this.event.numberOfOpenings - jobblesAndApplicants.length;
            this.event.numberOfPendingApplications = this.event.numberOfPendingApplications - jobblesAndApplicants.length;
            this.$tracking.reportApplicationAcceptance(this.event, this.currentUser, trackingData);
            this.resetApprovedApplicants();
            this.ui.allChecked = false;
            this.removeHiredApplicantsFromPendingPool(jobblesAndApplicants, response);
            this.reloadApplicants();
          }, 2000);
        },
        (response) => {
          console.log("was it a total failure");
          console.dir(response);
          this.remain_loading_count--;
          this.$timeout(() => {
            jQuery("#show-application-alert").trigger("click");
          }, 100);
          this.reloadApplicants();
        }
      );
    }
  }

  removeHiredApplicantsFromPendingPool(jobblesAndApplicant, response) {
    let removeArray = [];

    try {
      this.allApplicants.forEach((app) => {
        if (app.applicationStatus === 3 || app.applicationStatus === null) {
          jobblesAndApplicant.forEach((a) => {
            if (a.applicant === app.applicantId) {
              app.isChecked = true;
              removeArray.push(app);
            }
          });
        }
      });
    } catch (e) {
      console.log("error : " + e);
    } finally {
      console.log("we have them in the remove array");
      console.dir(removeArray);

      removeArray.forEach((app) => {
        this.removeHireApplicant(app);
        this.hiredApplicants.push(app);
      });

      console.log("hired apps..");
      console.dir(this.hiredApplicants);

      this.confirmJobblersHiredModal(jobblesAndApplicant, response);
    }
  }

  confirmJobblersHiredModal(jaa, response) {
    let hireMessage;

    if (jaa.length > 1) {
      hireMessage = "Congratulations on your new the hires!";
    } else {
      hireMessage = "Congratulations on your new the hire!";
    }

    this.$timeout(() => {
      $("#modal-congrats-hire").modal();
      this.statusNumbers[1] = this.statusNumbers[1] + jaa.length;
    }, 150);

    this.$timeout(() => {
      this.unSetLoader();
    }, 1000);
  }

  sendToHires() {
    this.setTabFilter(1);
    this.$timeout(() => {
      $("#modal-congrats-hire").modal("toggle");
    }, 150);
  }

  closeCongratsMessage() {
    this.$timeout(() => {
      $("#modal-congrats-hire").modal("toggle");
    }, 150);

    this.$timeout(() => {
      this.$state.go("jobsdashboard");
    }, 700);
  }

  resetApprovedApplicants() {
    var _this = this;
    _this.approvedApplicants = [];
  }

  handlePut(id, response, trackingData, arg) {
    var _this = this;
    var application = response.data;

    _this.pendingApplicants.forEach(function (applicant, i) {
      if (applicant.id === id) {
        _this.pendingApplicants.splice(i, 1);
        _this.acceptedApplicants.push(applicant);
      }
    });
    if (arg) {
      if (arg.action === "close") {
        _this.$timeout(function () {
          jQuery("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
        });
      }
    } else {
      _this.$timeout(function () {
        jQuery("#modal-hire-jobbler .modal-header button.close").trigger("click");
      });
    }
    _this.fancyLoad("#review-accepted-applicants tbody tr", _this.acceptedApplicants.length);
    _this.resetApprovedApplicants();
    _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications + 1;
    _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - 1;
  }

  adjustJobblers(jobbler) {
    var _this = this;
    _this.pendingApplicants.forEach(function (applicant, i) {
      if (applicant.applicant.id === jobbler.jobblerId) {
        _this.acceptedApplicants.push(applicant);
        _this.pendingApplicants.splice(i, 1);
      }
    });
    _this.event.numberOfApprovedApplications = _this.event.numberOfApprovedApplications + 1;
    _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications - 1;
  }

  removeJobbler() {
    var _this = this;
    var removeJobblerData = {
      method: "POST",
      url:
        _this.$env.getAPIEndPoint() +
        "jbl/v1/users/" +
        _this.selectedApplicant.applicant.id +
        "/jobbles/" +
        _this.selectedApplicant.jobbleId +
        "/reject?format=json",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + _this.currentUser.access_token,
      },
      data: {},
    };
    _this.remain_loading_count++;
    _this.$http(removeJobblerData).then(
      function (response) {
        _this.remain_loading_count--;
        if (response.data.status === "OK") {
          var index = null;
          for (var i = 0; i < _this.acceptedApplicants.length; i++) {
            if (_this.acceptedApplicants[i].id === _this.selectedApplicant.id) index = i;
          }
          if (!_this.$security.isUndefinedOrNull(index)) _this.acceptedApplicants.splice(index, 1);
        }
        _this.$timeout(function () {
          jQuery("#modal-remove-jobbler .modal-header button.close").trigger("click");
        }, 100);
      },
      function (response) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  connectJobblerFromApplicantsPage(application) {
    var _this = this;
    var eventForParam = _this.event;
    _this.remain_loading_count++;
    if (_this.paymentInfos.length == 0) {
      _this.$timeout(function () {
        jQuery("#link-modal-add-card").trigger("click");
        if (_this.isSourcingPost) {
          _this.$rootScope.isSourcingJobForPayment = true;
        }
        _this.remain_loading_count--;
      });
      return;
    }
    _this.$security.getApplicationInfoTrimmed(application).then(function (response) {
      var jobblerData = _this.$security.getJobblerData(response.data, "default", "open", application.renderPhotoThumb);
      _this.$timeout(function () {
        _this.$rootScope.$emit("GetJobblerDataFromService", {
          event: _this.event,
          jobblerData: jobblerData,
        });
        _this.$rootScope.$emit("CollectCardsForConnect", {});
        jQuery("#modal-connect-jobbler-click").trigger("click");
      });
      _this.$timeout(function () {
        _this.remain_loading_count--;
      }, 700);
    });
  }

  setJobblerRating(acceptedApplication) {
    var _this = this;
    if (!_this.$security.isUndefinedOrNull(acceptedApplication.renderPhoto)) {
      acceptedApplication.renderPhotoThumb = acceptedApplication.renderPhoto;
    } else {
      acceptedApplication.renderPhotoThumb = acceptedApplication.renderPhotoBig;
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 0) {
      acceptedApplication.applicant.displayRating = 1;
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 1) {
      acceptedApplication.applicant.displayRating = 1;
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 2) {
      acceptedApplication.applicant.displayRating = 2;
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 3) {
      acceptedApplication.applicant.displayRating = 3;
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 4) {
      acceptedApplication.applicant.displayRating = 4;
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 5) {
      acceptedApplication.applicant.displayRating = 5;
    }
    _this.noOneAcceptedYet = false;
    _this.getPaymentInfoAccepted(acceptedApplication);
  }

  setJobblerRatingNew(application) {
    if (!this.$security.isUndefinedOrNull(application.renderPhoto)) {
      application.renderPhotoThumb = application.renderPhoto;
    } else {
      application.renderPhotoThumb = application.renderPhotoBig;
    }

    if (Math.round(application.applicant.averageRatingReceived) === 0) {
      application.applicant.displayRating = 1;
    }
    if (Math.round(application.applicant.averageRatingReceived) === 1) {
      application.applicant.displayRating = 1;
    }
    if (Math.round(application.applicant.averageRatingReceived) === 2) {
      application.applicant.displayRating = 2;
    }
    if (Math.round(application.applicant.averageRatingReceived) === 3) {
      application.applicant.displayRating = 3;
    }
    if (Math.round(application.applicant.averageRatingReceived) === 4) {
      application.applicant.displayRating = 4;
    }
    if (Math.round(application.applicant.averageRatingReceived) === 5) {
      application.applicant.displayRating = 5;
    }

    return application;
  }

  setJobblerRatingPending(pendingApplication) {
    var _this = this;
    if (!_this.$security.isUndefinedOrNull(pendingApplication.renderPhoto)) {
      pendingApplication.renderPhotoThumb = pendingApplication.renderPhoto;
    } else {
      pendingApplication.renderPhotoThumb = pendingApplication.renderPhotoBig;
    }
    if (Math.round(pendingApplication.applicant.averageRatingReceived) === 0) {
      pendingApplication.applicant.displayRating = 1;
    }
    if (Math.round(pendingApplication.applicant.averageRatingReceived) === 1) {
      pendingApplication.applicant.displayRating = 1;
    }
    if (Math.round(pendingApplication.applicant.averageRatingReceived) === 2) {
      pendingApplication.applicant.displayRating = 2;
    }
    if (Math.round(pendingApplication.applicant.averageRatingReceived) === 3) {
      pendingApplication.applicant.displayRating = 3;
    }
    if (Math.round(pendingApplication.applicant.averageRatingReceived) === 4) {
      pendingApplication.applicant.displayRating = 4;
    }
    if (Math.round(pendingApplication.applicant.averageRatingReceived) === 5) {
      pendingApplication.applicant.displayRating = 5;
    }
    pendingApplication.isHireSelected = false;
    pendingApplication.isHireSelectedLast = false;
    _this.getPaymentInfoPending(pendingApplication);
  }

  scrollPendingApplicants() {
    var _this = this;
    if (_this.pendingApplicants.length !== _this.event.numberOfPendingApplications && _this.thereArePendingApplicant) {
      _this.busy = true;
      _this.$scroll
        .loadMoreApplicationsReviewPage(_this.event.subEvents[0].id, _this.pendingApplicants.length, 8, _this.$env, 3)
        .then(function (pendingApplications) {
          if (pendingApplications.data) {
            try {
              if (pendingApplications.data.length === 0) {
                _this.thereArePendingApplicant = false;
              }
              if (pendingApplications.data.length !== 0) {
                pendingApplications.data.forEach(function (pendingApplication) {
                  pendingApplication.hasBeenSelected = false;
                  pendingApplication.renderPhoto = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
                  pendingApplication.renderPhotoThumb = pendingApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
                  _this.setJobblerRatingPending(pendingApplication);
                  _this.fancyLoad(".reviewing-applicants-table tbody tr", _this.pendingApplicants.length);
                });
              }
            } catch (err) {
              console.log("error scrolling applicants");
              console.dir(err);
            } finally {
              let len = pendingApplications.data.length;
              if (len < 8) {
                _this.busy = false;
                _this.sortPendingApplicants();
              } else {
                _this.scrollPendingApplicants();
              }
            }
          }
        });
    }
  }

  scrollAcceptedApplicants() {
    var _this = this;
    if (_this.acceptedApplicants.length !== _this.event.numberOfApprovedApplications && _this.thereAreAcceptedApplicant) {
      _this.busyAccepted = true;
      _this.$scroll
        .loadMoreApplicationsReviewPage(_this.event.subEvents[0].id, _this.acceptedApplicants.length, 8, _this.$env, 1)
        .then(function (acceptedApplications) {
          try {
            if (acceptedApplications.data.length === 0) {
              _this.thereAreAcceptedApplicant = false;
            }
            if (acceptedApplications.data.length !== 0) {
              acceptedApplications.data.forEach(function (acceptedApplication) {
                acceptedApplication.renderPhoto = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
                acceptedApplication.renderPhotoThumb = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
                _this.setJobblerRating(acceptedApplication);
                _this.fancyLoad("#review-accepted-applicants tbody tr", _this.acceptedApplicants.length);
              });
            }
          } catch (err) {
          } finally {
            let len = acceptedApplications.data.length;
            if (len < 8) {
              _this.busyAccepted = false;
              _this.sortAcceptedApplicants();
            } else {
              _this.scrollAcceptedApplicants();
            }
          }
        });
    }
  }

  sortSet(x) {
    var _this = this;
    var list = _this.pendingApplicants;
    var header = x;
    var prop = x.prop;
    if (header.order === 1) {
      header.order = 2;
    } else {
      header.order = 1;
    }
    switch (prop) {
      case 1:
        _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
        break;
      case 2:
        _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
        break;
      case 3:
        _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
        break;
      case 4:
        _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
        break;
      case 5:
        _this.pendingApplicants = _this.$scroll.sortSet(list, prop, header);
        break;
    }
  }

  displayStatusText(data) {
    return data.jobblerScheduleManagementStatus;
  }

  getBirthDate(application, date) {
    application.applicant.age = moment().diff(moment(date), "years");
    return application.applicant.age;
  }

  scrollToBottomOfPage() {
    var _this = this;
    _this.$location.hash("anchor-for-top-link");
    _this.$anchor();
  }

  generateApprovedApplicantList() {
    var _this = this;
  }

  sortSurveyQuestions(questions) {
    var _this = this;
    questions.sort(function (a, b) {
      if (a.id < b.id) return -1;
      if (a.id > b.id) return 1;
      return 0;
    });
  }

  handleProfilePagination(params) {
    var _this = this;
    var nextIndex = null;
    var app = {};
    app.direction = params.data.direction;
    if (params.data.type === "default") {
      if (params.data.direction === "next") {
        nextIndex = params.data.index + 1;
        app.id = _this.pendingApplicants[params.data.index + 1].id;
      } else {
        nextIndex = params.data.index - 1;
        app.id = _this.pendingApplicants[params.data.index - 1].id;
      }
    } else {
      if (params.data.direction === "next") {
        nextIndex = params.data.index + 1;
        app.id = _this.acceptedApplicants[params.data.index + 1].id;
      } else {
        nextIndex = params.data.index - 1;
        app.id = _this.acceptedApplicants[params.data.index - 1].id;
      }
    }
    _this.displayDetails(app, params.data.type, params.data.action, nextIndex);
  }

  setTableHeaders() {
    var _this = this;
    if (!_this.event.isSourcingPost) {
      this.tableHeaders = [
        {value: ""},
        {
          value: "Name",
          imageUrl: "/app/vendor/images/sortingall.png",
          order: 2,
          prop: 1,
        },
        {
          value: "Job Exp.",
          imageUrl: "/app/vendor/images/sortingall.png",
          order: 2,
          prop: 2,
          title: "Jobs Completed",
        },
        {value: "City", title: "City"},
        {
          value: "Rating",
          imageUrl: "/app/vendor/images/sortingall.png",
          order: 2,
          prop: 4,
          title: "Average Rating Received",
        },
        {value: ""},
        {value: ""},
      ];
    } else {
      this.tableHeaders = [
        {value: ""},
        {
          value: "Name",
          imageUrl: "/app/vendor/images/sortingall.png",
          order: 2,
          prop: 1,
        },
        {
          value: "Rating",
          imageUrl: "/app/vendor/images/sortingall.png",
          order: 2,
          prop: 4,
        },
        {value: "Message"},
        {value: "No"},
        {value: "Yes"},
      ];
    }
  }

  handleConnect(usersAndApplications) {
    var _this = this;
    _this.$events.connect(usersAndApplications).then(
      function (response) {
        console.log("response");
        console.dir(response);
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  toggleActionMenu(job, index, call) {
    let i = index + 1;

    if (this.tabFilter === 1 && $("table.jobble-table").length > 1) {
      if (call === 2) {
        this.$timeout(() => {
          $("table.jobble-table:first-child tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
        });
        this.$timeout(() => {
          $("table.jobble-table:first-child tbody tr:nth-child(" + i + ") td").toggleClass("row-focus");
        }, 150);
        this.$timeout(() => {
          $("table.jobble-table:first-child tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
        }, 300);
      } else if (call === 3) {
        if ($("table.jobble-table tbody tr.confirmation-red").length > 0) {
          this.$timeout(() => {
            $("table.jobble-table tbody tr.confirmation-red:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
          });
          this.$timeout(() => {
            $("table.jobble-table tbody tr.confirmation-red:nth-child(" + i + ") td").toggleClass("row-focus");
          }, 150);
          this.$timeout(() => {
            $("table.jobble-table tbody tr.confirmation-red:nth-child(" + i + ") td:last-child .action-menu").focus();
          }, 300);
        } else if ($("table.jobble-table tbody tr.no-confirm").length > 0) {
          this.$timeout(() => {
            $("table.jobble-table tbody tr.no-confirm:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
          });
          this.$timeout(() => {
            $("table.jobble-table tbody tr.no-confirm:nth-child(" + i + ") td").toggleClass("row-focus");
          }, 150);
          this.$timeout(() => {
            $("table.jobble-table tbody tr.no-confirm:nth-child(" + i + ") td:last-child .action-menu").focus();
          }, 300);
        }
      }
    } else {
      this.$timeout(() => {
        $("table.jobble-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").slideToggle({duration: 100});
      });
      this.$timeout(() => {
        $("table.jobble-table tbody tr:nth-child(" + i + ") td").toggleClass("row-focus");
      }, 150);
      this.$timeout(() => {
        $("table.jobble-table tbody tr:nth-child(" + i + ") td:last-child .action-menu").focus();
      }, 300);
    }
  }

  getPaymentInfoPending(application) {
    var _this = this;
    if (_this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos && application.applicant.undeletedPaymentInfos.length === 0) {
      application.showPayInfoWarning = true;
    }
    _this.pendingApplicants.push(application);
  }

  getPaymentInfoPendingNew(application) {
    if (this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos && application.applicant.undeletedPaymentInfos.length === 0) {
      application.showPayInfoWarning = true;
    }

    return application;
  }

  getPaymentInfoAccepted(application) {
    var _this = this;
    if (_this.currentUser.isAdmin && application.applicant.undeletedPaymentInfos.length === 0) {
      application.showPayInfoWarning = true;
    }
    _this.acceptedApplicants.push(application);
  }

  fixApplicantPhone(application) {
    var _this = this;
    if (application.applicant.homeContactInfo) {
      if (application.applicant.homeContactInfo.phoneMobile) {
        let num = application.applicant.homeContactInfo.phoneMobile;
        if (num.charAt(0) === "1") {
          num = num.slice(1, num.length);
        }
        let cleaned = ("" + num).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          application.applicant.homeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
        } else {
          application.applicant.homeContactInfo.phoneMobile = num;
        }
      } else {
        application.applicant.homeContactInfo = {};
        application.applicant.homeContactInfo.phoneMobile = "--";
      }
    }
  }

  fixApplicantPhoneNew(application) {
    if (application.applicantHomeContactInfo) {
      if (application.applicantHomeContactInfo.phoneMobile) {
        let num = application.applicantHomeContactInfo.phoneMobile;
        if (num.charAt(0) === "1") {
          num = num.slice(1, num.length);
        }
        let cleaned = ("" + num).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          application.applicantHomeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
        } else {
          application.applicantHomeContactInfo.phoneMobile = num;
        }
      } else {
        application.applicantHomeContactInfo = {};
        application.applicantHomeContactInfo.phoneMobile = "--";
      }
    }

    return application;
  }

  fixApplicantNameNew(application) {
    if (!application) return application;

    let last_name = application.applicantLastName ? application.applicantLastName.toLowerCase() : "--";
    let first_name = application.applicantFirstName ? application.applicantFirstName.toLowerCase() : "--";

    application.applicantLastName = last_name.charAt(0).toUpperCase() + last_name.slice(1);
    application.applicantFirstName = first_name.charAt(0).toUpperCase() + first_name.slice(1);

    application.applicantEmail = application.applicantEmail ? application.applicantEmail.toLowerCase() : "--";

    return application;
  }

  fixApplicantName(application) {
    var _this = this;
    let last_name = application.applicant.lastName.toLowerCase();
    let first_name = application.applicant.firstName.toLowerCase();
    let test_length = last_name + first_name;
    application.applicant.lastName = last_name.charAt(0).toUpperCase() + last_name.slice(1);
    application.applicant.firstName = first_name.charAt(0).toUpperCase() + first_name.slice(1);
    application.applicant.username = application.applicant.username.toLowerCase();
  }

  triggerOpeningsModal() {
    var _this = this;
    _this.$timeout(function () {
      $("#reached-openings-limit").modal("toggle");
    });
    _this.$timeout(function () {
      $("#modal-add-openings").modal();
    }, 300);
  }

  sortApplicationsByField(field, applications) {
    if (!applications || !applications.length) return applications;

    applications.sort((a, b) => {
      if (a.applicant.firstName < b.applicant.firstName) return -1;
      if (a.applicant.firstName > b.applicant.firstName) return 1;
      return 0;
    });

    return applications;
  }

  sortPendingApplicants() {
    var _this = this;
    _this.pendingApplicants.sort(function (a, b) {
      if (a.applicant.firstName < b.applicant.firstName) return -1;
      if (a.applicant.firstName > b.applicant.firstName) return 1;
      return 0;
    });
    _this.$timeout(function () {
      _this.checkForOverLaps();
    }, 500);
  }

  sortAcceptedApplicants() {
    var _this = this;
    _this.acceptedApplicants.sort(function (a, b) {
      if (a.applicant.lastName < b.applicant.lastName) return -1;
      if (a.applicant.lastName > b.applicant.lastName) return 1;
      return 0;
    });
    //loading applicants -- latest code
  }

  loadRejectedApplicants() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("LoadRejectedApplicants", _this.event);
    }, 300);
  }

  setRejectedApplicantToDirective(applicant) {
    var _this = this;
    console.log("setRejectedApplicantToDirective");
    console.dir(applicant);
    _this.$timeout(function () {
      _this.$rootScope.$emit("setRejectedApplicantToDirective", applicant);
    });
  }

  mapRejectedApplicantToPendingApplicants(app) {
    var _this = this;

    let application = {};

    application.applicant = {};
    application.applicant.homeContactInfo = {};
    application.jobble = {};
    application.applicant.email = app.applicantEmail;
    application.applicant.username = app.applicantEmail;
    application.applicant.homeContactInfo.phoneMobile = app.applicantPhoneNumber;
    application.applicant.homeContactInfo.city = app.applicantHomeContactInfo.city;
    application.applicant.homeContactInfo.state = app.applicantHomeContactInfo.state;
    application.applicant.id = app.applicantId;
    application.applicant.displayRating = Math.round(app.averageRatingReceived);
    application.applicant.isVerified = app.isApplicantVerified;
    application.applicant.numberOfCompletedJobbles = app.numberOfCompletedJobbles;
    application.applicant.firstName = app.applicantFirstName;
    application.applicant.lastName = app.applicantLastName;
    application.applicant.filePROFILE_IMAGE1IMG_75x75 = app.filePROFILE_IMAGE1IMG_75x75;
    application.jobble.id = app.jobbleId;
    application.id = app.id;
    _this.event.numberOfPendingApplications = _this.event.numberOfPendingApplications + 1;
    _this.pendingApplicants.unshift(application);
    _this.fancyLoad(".reviewing-applicants-table tbody tr", _this.pendingApplicants.length);
  }

  launchPendingModal() {
    var _this = this;
    console.log("launchPendingModal");
  }

  fancyLoad(cls, length) {
    var _this = this;
    _this.$auth.fancyLoad(cls, length);
  }

  calcAccepted(actual, api) {
    var _this = this;
    if (actual > api) {
      _this.event.numberOfApprovedApplications = actual;
    }
    return actual;
  }

  calcPending(actual, api) {
    var _this = this;
    if (actual > api) {
      _this.event.numberOfPendingApplications = actual;
    }
    return actual;
  }

  checkForOverLaps() {
    let apps = this.allApplicants;
    let array = [];

    try {
      this.allApplicants.forEach((app) => {
        let newApp = {};
        if (app.applicationStatus && app.applicationStatus !== 3) return;
        newApp.jobbleId = app.jobbleId;
        newApp.userId = app.applicantId;
        newApp.appId = app.id;
        array.push(newApp);
      });
    } catch (err) {
      console.log("Error Looping applicants");
      console.dir(err);
    } finally {

      if (array.length > 0) {
        this.$events.checkForOverlaps(array).then(
          (response) => {
            this.$timeout(() => {
              this.markPendingApplicationAsOverlapped(apps, response.data);
            });

            this.overlaps = response.data;

            this.$timeout(() => {
              //this.unSetLoader();
            }, 300);
          },
          (error) => {
            this.unSetLoader();
          }
        );
      }
    }
  }

  setEventOpenings(event) {
    this.$timeout(() => {
      this.$rootScope.$emit("SetEventToEventDialog", {
        event: this.event,
      });
    });
  }

  markPendingApplicationAsOverlapped(apps, applicationIds) {
    var _this = this;

    let tempApp = null;

    console.log("markPendingApplicationAsOverlapped");
    console.log(apps, applicationIds);

    try {
      applicationIds.forEach((idObj) => {
        console.log(idObj);

        const applicantId = idObj.id;

        console.log("applicantId", applicantId);

        let temp = this.allApplicants.find((o) => o.id === idObj.id);

        if (temp) {
          temp.hasOverlapNew = true;
          temp.hasOverlappingJob = true;
          temp.hasOverlappingJobAndHired = false;

          idObj.conflictingJobbles.forEach((jobble) => {
            if (jobble.applicationStatus === 1) {
              temp.hasOverlappingJobAndHired = true;
            }
          });

          temp.conflictingJobbles = idObj.conflictingJobbles;
        } else {
          temp.hasOverlapNew = temp.hasOverlapNew || false;
          temp.hasOverlappingJob = temp.hasOverlappingJob || false;
          temp.hasOverlappingJobAndHired = temp.hasOverlappingJobAndHired || false;
          temp.conflictingJobbles = temp.conflictingJobbles || [];
        }

        console.log(temp);
      });
    } finally {
      this.enableToolTips();
    }
  }

  displayOverlappingJobbles(app, index) {
    var _this = this;

    _this.setLoader();
    try {
      _this.pendingApplicants.forEach(function (a) {
        if (a.isOpen === true) {
          console.log("we have one that  is open..");
          a.isOpen = false;
        }
      });
    } finally {
      _this.$timeout(function () {
        if (app.isOpen) {
          app.isOpen = false;
          _this.$timeout(function () {
            $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").removeClass("display-overlap-modal");
          });
        } else {
          app.isOpen = true;
          _this.$timeout(function () {
            $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").addClass("display-overlap-modal");
          });
          _this.$timeout(function () {
            $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").focus();
          }, 200);
        }
        let overlapsToShow = _this.overlaps.find((o) => o.id === app.id);
        _this.o = overlapsToShow;
        _this.unSetLoader();
      }, 300);
    }
  }

  findLinks(ol) {
    var _this = this;
    ol.conflictingJobbles.forEach(function (lap) {
      if (lap.companyName === _this.currentUser.company.name) {
      }
    });
  }

  closeOverlaps(app, index) {
    var _this = this;

    app.isOpen = false;
    _this.$timeout(function () {
      $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").removeClass("display-overlap-modal");
    });
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  checkApplicant(applicant) {
    applicant.isChecked = applicant.isChecked !== true;
    this.checkForAtleastOneCheckedApplicant();
  }

  checkAll(onlyHired) {
    console.log("check all");
    console.dir(onlyHired);
    if (this.ui.allChecked === false) {
      console.log("we need to check.");
      this.ui.allChecked = true;
      this.checkOrUncheckAll(true, onlyHired);
    } else {
      this.ui.allChecked = false;
      this.checkOrUncheckAll(false, onlyHired);
    }

    this.checkForAtleastOneCheckedApplicant();
  }

  checkForAtleastOneCheckedApplicant() {
    this.weHaveOneCheckedJob = false;

    if (!this.allApplicants || !this.allApplicants.length) {
      this.ui.allChecked = false;
      return;
    }

    this.allApplicants.forEach((applicant) => {
      if (applicant.isChecked === true) {
        this.weHaveOneCheckedJob = true;
      }
    });

    if (this.weHaveOneCheckedJob === false) {
      this.ui.allChecked = false;
    }
  }

  checkOrUncheckAll(checked, onlyHired) {
    if (!this.allApplicants || !this.allApplicants.length) {
      this.checkForAtleastOneCheckedApplicant();
      return;
    }

    let checkedUsers = [];

    try {
      this.allApplicants.forEach((applicant) => {
        if (onlyHired) {
          if (applicant.applicationStatusRoster.id === 1) {
            applicant.isChecked = false;

            if (this.confirmationFilters.all) applicant.isChecked = checked;

            let confirmationResponseExists = false;
            let confirmationResponse = false;

            if (
              this.shiftConfirmationData &&
              this.shiftConfirmationData[this.singleShiftViewShiftPosition] &&
              this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId]
            ) {

              confirmationResponseExists =
                this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;
              confirmationResponse = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse;

            }

            if (this.confirmationFilters.confirmed && confirmationResponseExists && confirmationResponse) applicant.isChecked = checked;

            if (this.confirmationFilters.declined && confirmationResponseExists && !confirmationResponse) applicant.isChecked = checked;

            if (this.confirmationFilters.no_response && !confirmationResponseExists) applicant.isChecked = checked;

          } else {
            applicant.isChecked = false;
          }
        } else {
          if ((applicant.applicationStatusRoster.id || 3) === this.tabFilter) {
            applicant.isChecked = checked;
            checkedUsers.push(applicant);
          } else {
            applicant.isChecked = false;
          }
        }
      });
    } catch (err) {
      console.error(err);
    } finally {
      console.log("all checked users");
      console.dir(checkedUsers);
    }

    this.checkForAtleastOneCheckedApplicant();
  }

  enterCheckInOutTime(applicant, status, index, removedUser) {

    console.log("enterCheckInOutTime");
    console.dir(applicant);
    console.dir(status);
    console.dir(index);
    console.dir(removedUser);
    //console.dir(this.shiftOptions[0]);
    console.dir(this.shiftConfirmationData[this.singleShiftViewShiftPosition]);

    if (removedUser) {
      let randomShift = this.shiftOptions[0];
      this.setSingleShiftView(randomShift, 0);
    }

    this.$tracking.reportRosterPageView(`check in/out modal`);

    this.selectedstatus = status;

    this.$timeout(() => {
      this.editCheckInTime = false;
      this.editCheckOutTime = false;

      this.editCheckInTimes = {};
      this.editCheckOutTimes = {};

      jQuery("#timepicker-rosterstamp-1").timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp-1").on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-1").width() + 10 + "px");
      });

      jQuery("#timepicker-rosterstamp-2").timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp-2").on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-2").width() + 10 + "px");
      });

      this.check_in_data = {};
      this.check_in_data.application = applicant;
      this.check_in_data.status = status;
      this.check_in_data.index = index;

      this.selectedjobbler = applicant;

      console.log("time", this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId]);
      console.log("time", this.shiftConfirmationData[this.singleShiftViewShiftPosition]);
      console.log("time", this.shiftConfirmationData);

      const checkInTimeMoment = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].checkInTimeMoment;
      const checkOutTimeMoment = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].checkOutTimeMoment;

      this.selectedjobbler.checkInTimeFormatted = checkInTimeMoment ? checkInTimeMoment.format("hh:mm A") : null;
      this.selectedjobbler.checkOutTimeFormatted = checkOutTimeMoment ? checkOutTimeMoment.format("hh:mm A") : null;

      this.selectedjobbler.jobblerNote = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].jobblerNote || null;
      this.selectedjobbler.confirmationResponse =
        this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponse || null;
      this.selectedjobbler.confirmationResponseExists =
        this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].confirmationResponseExists;

      jQuery("#modal-check-user-in-link").modal({
        backdrop: true,
      });

      const shift = this.singleShiftViewShift;
      this.setModalSingleShiftView(shift, this.singleShiftViewOriginalIndex, applicant, true);

      this.enableToolTips();
    }, 100);
  }

  determineTimeToDisplay(shiftData) {
    console.log("determineTimeToDisplay");
    console.dir(shiftData);
    console.dir(this.selectedjobbler);
    //console.dir(this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId]);
    console.dir(this.shiftOptions);
  }

  setModalSingleShiftView(shift, index, applicant, init) {
    console.log("setModalSingleShiftView");
    console.dir(shift);
    console.dir(applicant);
    console.dir(init);
    console.dir(this.shiftOptions);
    //console.dir(this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId]);
    applicant = applicant || this.selectedjobbler;
    this.modalSingleShiftViewId = shift.id;
    this.modalSingleShiftViewShift = shift;
    this.modalSingleShiftViewShiftPosition = shift.shiftPosition;
    this.modalSingleShiftViewFormatted = `Shift ${index + 1}: ${shift.shiftDateFormatted} ${shift.shiftTZ}`;

    this.selectedjobbler.jobblerNote = this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId].jobblerNote || null;

    const coordsForCheckIn = {
      lat: shift.contactInfo.lat,
      lng: shift.contactInfo.lng,
    };
    this.loadMap(
      coordsForCheckIn.lat,
      coordsForCheckIn.lng,
      this.shiftConfirmationData[shift.shiftPosition][applicant.applicantId],
      shift.contactInfo,
      applicant,
      init
    );

    this.$tracking.reportRosterPageClick("confirmation modal shift view");
  }

  showOverlappingJobbles(applicant) {
    this.$tracking.reportRosterPageView(`overlapping jobbles`);

    this.$timeout(() => {
      this.selectedjobblerOverlapping = applicant;

      jQuery("#modal-overlapping").modal();
    }, 100);
  }

  openMakeShiftPayment() {
    console.log("openMakeShiftPayment");
    console.dir(this.singleShiftViewShift);

    this.processWhoCanBePaid();
    this.clearAllCards();

    /*
    if (!this.readyToPay.length) {
      alert("There are no more users that need to be paid for this shift.");
      return;
    }
    */

    if (this.weHaveOneCheckedJob) return;

    this.confirmAllHaveHours();

    this.$timeout(() => {
      jQuery("#modal-shift-payment").modal({
        backdrop: true,
      });
    }, 100);

    this.enableToolTips();

    this.$timeout(() => {
      $(".remove-from-p-list").tooltip({});
    }, 200);

    jQuery("#modal-shift-payment")
      .unbind("hidden.bs.modal")
      .on("hidden.bs.modal", () => {
        console.log("Modal CLOSED");

        this.$timeout(() => {
          this.processWhoCanBePaid();
        });
      });

    console.log("ready to pay");
    console.dir(this.readyToPay);
  }

  openMakeAdditionalPayment(jobbler) {
    this.clearAllCards();

    this.readyToAdditionalPay = [];
    this.additionalPaymentAmount = 0;
    this.additionalPaymentAmountJobbler = 0;

    if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;

    this.hiredApplicants.forEach((applicant, i) => {
      const {applicantId} = applicant;
      const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];

      if (!shiftData) return;

      if (shiftData.statusNumber === 4) {
        applicant.originalIndex = i;

        if (jobbler.applicantId === applicantId) {
          applicant.isReadyToAdditionalPayChecked = true;
        } else {
          applicant.isReadyToAdditionalPayChecked = false;
        }

        this.readyToAdditionalPay.push(applicant);
      }
    });

    this.verifyAtLeastOneReadyToAdditionalPayChecked();
    this.calculateAdditionalPaymentAmount();

    this.$timeout(() => {
      jQuery("#modal-additional-payment").modal();
    }, 100);

    this.enableToolTips();
  }

  closeDoneAdditionalModal(re) {
    jQuery("#modal-additional-payment-done .modal-header button.close").trigger("click");

    if (re) {
      window.location.href = "/receipts";
    }
  }

  closeDoneModal(re) {
    jQuery("#modal-shift-payment-done .modal-header button.close").trigger("click");

    if (re) {
      window.location.href = "/receipts";
    }
  }

  goToReceipts() {
    window.location.href = "/receipts";
  }

  clearAllCards() {
    this.uncheckPaymentInfo();
    this.selectedCard = null;
  }

  verifyAtLeastOneReadyToPayChecked() {
    this.atLeastOneReadyToPayChecked = false;

    this.readyToPay.forEach((applicant) => {
      if (applicant.isReadyToPayChecked) this.atLeastOneReadyToPayChecked = true;
    });
  }

  verifyAtLeastOneReadyToAdditionalPayChecked() {
    this.atLeastOneReadyToAdditionalPayChecked = false;

    this.readyToAdditionalPaySelected = [];
    this.readyToAdditionalPay.forEach((applicant) => {
      if (applicant.isReadyToAdditionalPayChecked) {
        this.readyToAdditionalPaySelected.push(applicant);
        this.atLeastOneReadyToAdditionalPayChecked = true;
      }
    });
  }

  closeRemoveFromPayment() {
    jQuery("#modal-remove-from-payment .modal-header button.close").trigger("click");
  }

  removeFromPayment(inApplicant) {
    this.applicantToRemoveFromPayment = inApplicant;

    this.$timeout(() => {
      jQuery("#modal-remove-from-payment").modal();
    }, 100);
  }

  removeFromPaymentConfirmed() {
    const inApplicant = this.applicantToRemoveFromPayment;

    this.readyToPayNew = this.readyToPay;

    this.$tracking.reportRosterPageSubmit("payment - remove from payment");

    this.readyToPay = this.readyToPay.map((applicant) => {
      if (applicant.applicantId === inApplicant.applicantId) {
        applicant.isReadyToPayChecked = false;
        return null;
      }

      return applicant;
    });

    this.readyToPay = _.without(this.readyToPay, null);
    this.closeRemoveFromPayment();
    this.verifyAtLeastOneReadyToPayChecked();
    this.calculateTotalPaymentOnEdit();
  }

  processWhoCanBePaid() {

    this.selectedCard = null;
    this.readyToPay = [];

    this.hasShowMoreApplicants = false;
    this.allUnconfirmedApplicants = true;
    this.allUsersHaveBeenPaidForThisShift = false;
    let paidUsers = [];

    if (
      !this.hiredApplicants ||
      !this.hiredApplicants.length ||
      !this.shiftConfirmationData ||
      !this.shiftConfirmationData[this.singleShiftViewShiftPosition]
    )
      return;

    if (this.removedApplicants) {
      try {
        this.removedApplicants.forEach((applicant, i) => {

          if (applicant.bgCheckStatus === "Pending") {
            return;
          }

          const {applicantId} = applicant;
          const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];

          applicant.shiftData = shiftData;

          if (!shiftData) return;

        });
      } catch (err) {
        console.log("error processing removed users");
        console.dir(err);
      } finally {
        console.log("finshed processing removed users");
      }
    }

    try {
      this.hiredApplicants.forEach((applicant, i) => {

        if (applicant.bgCheckStatus === "Pending") {
          return;
        }

        const {applicantId} = applicant;
        const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];

        applicant.shiftData = shiftData;

        if (!shiftData) return;

        if (shiftData.groupNumber !== 1) {
          this.hasShowMoreApplicants = true;
        } else {
          this.allUnconfirmedApplicants = false;
        }

        if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
          applicant.originalIndex = i;
          this.readyToPay.push(applicant);
        } else if (shiftData.statusNumber === 4) {
          paidUsers.push(applicant);
        } else if (shiftData.statusNumber === 5) {
          paidUsers.push(applicant);
        }
      });
    } catch (err) {
      console.log("error processing paid users");
      console.dir(err);
    } finally {
      if (this.hiredApplicants.length == paidUsers.length) {
        this.allUsersHaveBeenPaidForThisShift = true;
      }

      this.calculateTotalPayment();
    }

  }

  determineHoursBasedOffCheckinAndCheckOut(applicant) {
    let checkInTime = applicant.shiftData.checkInTimeMoment;
    let checkOutTime = applicant.shiftData.checkOutTimeMoment;
    let diffInMinutes = checkOutTime.diff(checkInTime, "minutes");
    let minutes = diffInMinutes % 60;
    let hours = Math.floor(diffInMinutes / 60);

    applicant.shiftData.paymentHours = hours;
    applicant.shiftData.totalMinutes = diffInMinutes;
    applicant.hours = hours;
    applicant.minutes = minutes;
  }

  blurTimeEdit(fromHTML, data, num) {
    this.$timeout(() => {
      if (fromHTML) {
        if (document.activeElement.className.includes("hours-edit-")) {
          console.log("do nothing.");
        } else {
          this.blurHoursUpdated(data);
        }
      }
    }, 100);
  }

  setFocusOnInput(num) {
    console.log("setFocusOnInput");
    if (num === 1) {
      this.$timeout(() => {
        $("input.hours-edit-1").focus();
      });
    } else if (num === 2) {
      this.$timeout(() => {
        $("input.hours-edit-2").focus();
      });
    } else if (num === 3) {
      this.$timeout(() => {
        $("input.hours-edit-3").focus();
      });
    } else if (num === 4) {
      this.$timeout(() => {
        $("input.hours-edit-4").focus();
      });
    }

    this.$timeout(() => {
      console.log("active element after focus");
      console.dir(document.activeElement);
    });
  }

  showMeData(data) {
    console.log("show me");
    console.dir(data);
  }

  setEditing(data, fromHTML) {
    console.log("set-editing-k");
    this.$timeout(() => {
      data.isEditingHours = true;
      data.isEditingMinutes = true;
      this.updatingHoursWorked = true;
    });

    if (fromHTML === 1 || fromHTML === 2 || fromHTML === 5) {
      this.$timeout(() => {
        $("input.hours-edit-1").focus();
      });
    } else if (fromHTML === 3 || fromHTML === 4) {
      this.$timeout(() => {
        $("input.hours-edit-2").focus();
      });
    } else if (fromHTML === 6 || fromHTML === 7 || fromHTML === 10) {
      this.$timeout(() => {
        $("input.hours-edit-3").focus();
      });
    } else if (fromHTML === 8 || fromHTML === 9) {
      this.$timeout(() => {
        $("input.hours-edit-4").focus();
      });
    }
  }

  calculateTotalPayment() {
    //console.log("calculateTotalPayment");
    //console.dir(this.readyToPay);

    if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;

    this.totalPaymentAmount = 0;
    this.totalPaymentAmountJobbler = 0;

    this.jobblersReadyForPayment = 0;
    this.jobblersReadyForPaymentContigency = 0;

    this.readyToPay.forEach((applicant, i) => {
      //console.log("ready to pay applicants");
      //console.dir(applicant);

      if (applicant.bgCheckStatus === "Pending") {
        return;
      }

      const {applicantId} = applicant;
      const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];

      //console.log("shift data");
      //console.dir(shiftData);

      if (!shiftData) return;

      this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].isEditingMinutes = false;
      this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].isEditingHours = false;

      if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
        if (shiftData.statusNumber === 3 && shiftData.actualMinutesWorked === null) {
          this.jobblersReadyForPaymentContigency += 1;

          // Toggle Setting Total Minutes to Zero
          this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].totalMinutes = 0;
          this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].timeInterval.timeInHours = 0;
          this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].timeInterval.timeInMinutes = 0;
          this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].payment = 0;
          this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId].paymentJobbler = 0;
        } else {
          if (shiftData.statusNumber === 1) {
            this.jobblersReadyForPayment += 1;
          } else {
            this.jobblersReadyForPaymentContigency += 1;
          }

          //console.log("this.totalPaymentAmount", this.totalPaymentAmount);
          this.totalPaymentAmount =
            parseFloat(this.totalPaymentAmount) +
            parseFloat(this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].payment);
          this.totalPaymentAmount = parseFloat(this.totalPaymentAmount);
          //console.log("this.totalPaymentAmount", this.totalPaymentAmount);

          //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
          this.totalPaymentAmountJobbler =
            parseFloat(this.totalPaymentAmountJobbler) +
            parseFloat(this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicant.applicantId].paymentJobbler);
          this.totalPaymentAmountJobbler = parseFloat(this.totalPaymentAmountJobbler);
          //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
        }
      }
    });

    this.confirmAllHaveHours();
  }

  calculateAdditionalPaymentAmount() {
    // this.additionalPaymentAmount = this.additionalPaymentAmountJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
    this.additionalPaymentAmount = this.additionalPaymentAmountJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

    this.totalAdditionalPaymentAmountJobbler = this.additionalPaymentAmountJobbler * this.readyToAdditionalPaySelected.length;
    this.totalAdditionalPaymentAmount = this.additionalPaymentAmount * this.readyToAdditionalPaySelected.length;
  }

  calculateTotalPaymentOnEdit() {
    if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;

    this.totalPaymentAmount = 0;
    this.totalPaymentAmountJobbler = 0;

    this.jobblersReadyForPaymentContigency = 0;

    const payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
    const payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

    this.readyToPay.forEach((applicant, i) => {
      const {applicantId} = applicant;
      const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];

      if (!shiftData) return;

      if (shiftData.statusNumber === 3 && shiftData.actualMinutesWorked === null) {
        this.jobblersReadyForPaymentContigency += 1;
      } else if (shiftData.statusNumber !== 1) {
        this.jobblersReadyForPaymentContigency += 1;
      }

      if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
        let totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
        let payment = (Math.round(((totalMinutes * payPerHour) / 100 / 60) * 100) / 100).toFixed(2);
        let paymentJobbler = (Math.round(((totalMinutes * payPerHourJobbler) / 100 / 60) * 100) / 100).toFixed(2);

        //console.log("user.payment", payment);
        //console.log("user.paymentJobbler", paymentJobbler);
        //console.dir((totalMinutes * payPerHour) / 100 / 60);

        shiftData.totalMinutes = totalMinutes;
        shiftData.payment = payment;
        shiftData.paymentJobbler = paymentJobbler;

        //console.log("this.totalPaymentAmount", this.totalPaymentAmount);
        //console.log("shiftData.payment", shiftData.payment, parseFloat(shiftData.payment));
        this.totalPaymentAmount = parseFloat(this.totalPaymentAmount) + parseFloat(shiftData.payment);
        this.totalPaymentAmount = parseFloat(this.totalPaymentAmount);
        //console.log("this.totalPaymentAmount", this.totalPaymentAmount);

        //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
        this.totalPaymentAmountJobbler = parseFloat(this.totalPaymentAmountJobbler) + parseFloat(shiftData.paymentJobbler);
        this.totalPaymentAmountJobbler = parseFloat(this.totalPaymentAmountJobbler);
        //console.log("this.totalPaymentAmountJobbler", this.totalPaymentAmountJobbler);
      }
    });

    this.confirmAllHaveHours();

    this.enableToolTips();
  }

  calculateTotalPaymentOnRejectionEdit() {
    if (!this.shiftConfirmationData || !this.shiftConfirmationData[this.singleShiftViewShiftPosition]) return;

    this.totalRejectionPaymentAmount = 0;
    this.totalRejectionPaymentAmountJobbler = 0;

    const payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
    const payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

    this.paymentContingenciesShiftPositions.forEach((shiftPosition) => {
      this.paymentContingenciesMap[shiftPosition].forEach((applicant) => {
        const {applicantId} = applicant;
        const shiftData = this.shiftConfirmationData[shiftPosition][applicantId];

        if (!shiftData) return;

        if (shiftData.statusNumber === 1 || shiftData.statusNumber === 2 || shiftData.statusNumber === 3) {
          let totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
          let payment = (Math.round(((totalMinutes * payPerHour) / 100 / 60) * 100) / 100).toFixed(2);
          let paymentJobbler = (Math.round(((totalMinutes * payPerHourJobbler) / 100 / 60) * 100) / 100).toFixed(2);

          console.log("user.payment", payment);
          console.log("user.paymentJobbler", paymentJobbler);
          console.dir((totalMinutes * payPerHour) / 100 / 60);

          shiftData.totalMinutes = totalMinutes;
          shiftData.payment = payment;
          shiftData.paymentJobbler = paymentJobbler;

          console.log("this.totalRejectionPaymentAmount", this.totalRejectionPaymentAmount);
          console.log("shiftData.payment", shiftData.payment, parseFloat(shiftData.payment));

          this.totalRejectionPaymentAmount = parseFloat(this.totalRejectionPaymentAmount) + parseFloat(shiftData.payment);
          this.totalRejectionPaymentAmount = parseFloat(this.totalRejectionPaymentAmount);
          console.log("this.totalRejectionPaymentAmount", this.totalRejectionPaymentAmount);

          console.log("this.totalRejectionPaymentAmountJobbler", this.totalRejectionPaymentAmountJobbler);
          this.totalRejectionPaymentAmountJobbler = parseFloat(this.totalRejectionPaymentAmountJobbler) + parseFloat(shiftData.paymentJobbler);
          this.totalRejectionPaymentAmountJobbler = parseFloat(this.totalRejectionPaymentAmountJobbler);
          console.log("this.totalRejectionPaymentAmountJobbler", this.totalRejectionPaymentAmountJobbler);
        }
      });
    });

    this.confirmAllRejectionsHaveHours();

    this.enableToolTips();
  }

  blurHoursUpdated(shiftData) {
    console.log("SUBMITTING EDIITNF DATA", shiftData);
    this.updatingHoursWorked = true;
    this.updateHoursWorked(shiftData);
    this.$timeout(() => {
      shiftData.isEditingHours = false;
      shiftData.isEditingMinutes = false;
    }, 300);
  }

  confirmAllHaveHours() {
    this.allHaveHours = true;

    try {
      this.readyToPay.forEach((applicant, i) => {
        const {applicantId} = applicant;
        const shiftData = this.shiftConfirmationData[this.singleShiftViewShiftPosition][applicantId];

        if (!shiftData) return;

        //console.log("TIMEESS", shiftData.timeInterval.timeInHours, shiftData.timeInterval.timeInMinutes);
        if (!shiftData.timeInterval.timeInHours && !shiftData.timeInterval.timeInMinutes) this.allHaveHours = false;

        if (shiftData.timeInterval.timeInHours || shiftData.timeInterval.timeInMinutes) {
          const payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
          // const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
          const payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

          let totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
          let payment = (Math.round(((totalMinutes * payPerHour) / 100 / 60) * 100) / 100).toFixed(2);
          let paymentJobbler = (Math.round(((totalMinutes * payPerHourJobbler) / 100 / 60) * 100) / 100).toFixed(2);

          //console.log("on change", payment, paymentJobbler);

          if (payment < 0.5) this.allHaveHours = false;
        }
      });
    } catch (err) {

    } finally {
      //console.log("ALL HAVE HOURS?", this.allHaveHours);
      this.prepareAllApplicantsCSV(this.allApplicants);
    }
  }

  confirmAllRejectionsHaveHours() {
    this.allRejectionsHaveHours = true;

    this.paymentContingenciesShiftPositions.forEach((shiftPosition) => {
      this.paymentContingenciesMap[shiftPosition].forEach((applicant) => {
        const {applicantId} = applicant;
        const shiftData = this.shiftConfirmationData[shiftPosition][applicantId];

        if (!shiftData) return;

        if (!shiftData.timeInterval.timeInHours && !shiftData.timeInterval.timeInMinutes) this.allRejectionsHaveHours = false;

        if (shiftData.timeInterval.timeInHours || shiftData.timeInterval.timeInMinutes) {
          const payPerHourJobbler = this.event.subEvents[0].deduppedJobbles[0].jobblerRate;
          // const payPerHour = payPerHourJobbler / (1 - this.currentUser.company.defaultPlan.jobblerFeePct);
          const payPerHour = payPerHourJobbler * (1 + this.currentUser.company.defaultPlan.companyFeePct);

          let totalMinutes = parseFloat(shiftData.timeInterval.timeInHours) * 60 + parseFloat(shiftData.timeInterval.timeInMinutes);
          let payment = (Math.round(((totalMinutes * payPerHour) / 100 / 60) * 100) / 100).toFixed(2);
          let paymentJobbler = (Math.round(((totalMinutes * payPerHourJobbler) / 100 / 60) * 100) / 100).toFixed(2);

          console.log("on change", payment, paymentJobbler);

          if (payment < 0.5) this.allRejectionsHaveHours = false;
        }
      });
    });

    console.log("ALL RJECTIONS HAVE HOURS?", this.allRejectionsHaveHours);
  }

  updateHoursWorked(data, silent) {
    if (this.updatingHoursWorkedBackend === true) {
      return;
    }

    this.updatingHoursWorkedBackend = true;
    let minutes = data.totalMinutes;
    let shiftId = data.shiftId;

    console.log("total minutes");
    console.dir(minutes);

    this.setLoader();

    data.actualMinutesWorked = minutes;

    this.$events.updateActualMinutesWorkedForShift(shiftId, minutes).then(
      (response) => {
        const {shiftPaid, checkInTime, checkOutTime, confirmationResponse} = data;
        let {
          status,
          statusNumber,
          groupNumber
        } = this.setApplicantStatus(data, shiftPaid, checkInTime, checkOutTime, confirmationResponse);

        data.status = status;
        data.statusNumber = statusNumber;
        data.groupNumber = groupNumber;

        this.calculateTotalPaymentOnEdit();

        this.confirmAllHaveHours();

        this.$timeout(() => {
          this.updatingHoursWorked = false;
          this.updatingHoursWorkedBackend = false;
          if (!silent) {
            this.unSetLoader();
          } else {
            this.unSetLoader();
          }
        }, 1000);
      },
      (error) => {
        const {shiftPaid, checkInTime, checkOutTime, confirmationResponse} = data;
        let {
          status,
          statusNumber,
          groupNumber
        } = this.setApplicantStatus(data, shiftPaid, checkInTime, checkOutTime, confirmationResponse);

        data.status = status;
        data.statusNumber = statusNumber;
        data.groupNumber = groupNumber;

        this.calculateTotalPaymentOnEdit();

        this.confirmAllHaveHours();

        this.$timeout(() => {
          this.updatingHoursWorked = false;
          this.updatingHoursWorkedBackend = false;
          if (!silent) {
            this.unSetLoader();
          } else {
            this.unSetLoader();
          }
        }, 1000);
      }
    );
  }

  toggleCheckInOrOutEdit(edit, checkOut) {
    if (checkOut) {
      this.editCheckOutTime = edit;
    } else {
      this.editCheckInTime = edit;
    }

    this.$timeout(() => {
      jQuery("#timepicker-rosterstamp-1").timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp-1").on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-1").width() + 10 + "px");
      });

      jQuery("#timepicker-rosterstamp-2").timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp-2").on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-2").width() + 10 + "px");
      });
    });
  }

  toggleCheckInOrOutEditNew(edit, checkOut, index) {
    this.$timeout(() => {
      if (checkOut) {
        this.editCheckOutTimes[index + ""] = edit;
      } else {
        this.editCheckInTimes[index + ""] = edit;
      }
    });

    this.$timeout(() => {
      jQuery("#timepicker-rosterstamp-in-" + index).timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp-in-" + index).on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-in-" + index).width() + 10 + "px");
      });

      jQuery("#timepicker-rosterstamp-out-" + index).timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp-out-" + index).on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp-out-" + index).width() + 10 + "px");
      });
    }, 100);
  }

  submitNewTimeForCheckInOrOut(checkOut, shift, timefull) {
    this.calcTimeZone(checkOut, shift, timefull);
  }

  calcTimeZone(checkOut, shift, timefull) {
    var date = null;
    var userTimeZoneName = moment.tz.guess();
    var now = moment.tz(userTimeZoneName);
    var dayfull = moment().format("MMM DD YYYY");

    if (!timefull) return;

    var nowThere = moment.tz(shift.contactInfo.place.timeZoneId);
    var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
    var zone = moment.tz.zone(moment.tz.guess());
    var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
    var eventOffsets = shift.contactInfo.place.rawOffset / 60000;
    var fulldate = dayfull + " " + timefull;
    var dateconverted = new Date(fulldate);

    var dateforDB = moment(dateconverted)
      .add(eventMangerOffsets - eventOffsets, "minutes")
      .format();

    let formatted_date = moment(dateconverted)
      .add(eventMangerOffsets - eventOffsets, "minutes")
      .format("hh:mm A");

    this.checkInOrOutJobblers([this.selectedjobbler], checkOut, formatted_date, dateforDB, shift);
  }

  closeAllOverLapsModals() {
    var _this = this;

    if (_this.pendingApplicants.length > 0) {
      _this.pendingApplicants.forEach(function (a, index) {
        if (a.isOpen === true) {
          a.isOpen = false;
          _this.$timeout(function () {
            $("#overlapping-jobbles-modal-wrapper-" + index + ".overlapping-jobbles-modal").removeClass("display-overlap-modal");
          });
        }
      });
    }
  }

  checkEventOpenings(eventId) {
    this.$events.getOpenings(eventId).then(
      (response) => {
        let openingsData = response.data;

        if (openingsData.numberOfOpenings === 0) {
          //disable hire button, show warning
          this.isThereRoomForHire = false;
        } else {
          //leave alone
          this.isThereRoomForHire = true;
        }

        this.$timeout(() => {
          //this.unSetLoader();
        }, 1000);
      },
      function (response) {
        console.log("we have an error getting openings");
        console.dir(response);
      }
    );
  }

  getUserTimeZone() {
    console.log("get user timezone");
    console.dir(Intl.DateTimeFormat().resolvedOptions().timeZone);
    let userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (userTimeZone) {
      this.timeZoneInfo = "Please be aware all times displayed below are in your local timezone (" + userTimeZone + ")";
    } else {
      this.timeZoneInfo = "Please be aware all times displayed below are in your local timezone";
    }
  }

  reloadRosterPage() {
    //checkInOrOutJobblerswindow.location.reload();
  }
}

EventreviewapplicantsController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "$stateParams",
  "security",
  "common",
  "scroll",
  "$rootScope",
  "$scope",
  "$window",
  "env",
  "$timeout",
  "messagingv2",
  "tracking",
  "$anchorScroll",
  "$location",
];

export default EventreviewapplicantsController;



// WEBPACK FOOTER //
// ./client/app/components/eventreviewapplicants/eventreviewapplicants.controller.js